var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgrammerRafiki(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.11,374.92c-1.07,0-2.15,0-3.25-.08l.19-4c57.91,2.82,74.68-77,85.76-129.75,4.24-20.18,7.59-36.12,12.24-43C224,173.23,251.89,177,252.17,177l-.57,4h0c-1.09-.16-25.78-3.37-41.24,19.38-4.21,6.2-7.65,22.58-11.63,41.55C187.57,295.07,170.81,374.91,112.11,374.92Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.28,361.83l-.28-4c33.82-2.34,52.86-39.63,71.28-75.69,10.34-20.27,20.12-39.41,32.31-52.41,34.5-36.79,51.14-31.48,51.83-31.24l-1.33,3.78.67-1.89-.63,1.9c-.15-.05-15.34-4.24-47.62,30.19C183.7,245.06,174.05,264,163.84,284,144.92,321,125.35,359.33,89.28,361.83Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.16,369.43l-1.22-3.81c11.66-3.76,18.79-17.51,27.05-33.44,10.07-19.44,21.49-41.46,44.79-53.66,42.67-22.34,94.78,6.45,97,7.69l-2,3.48c-.52-.29-52.44-28.95-93.16-7.63-22.19,11.62-33.3,33.05-43.1,52C129.88,350.73,122.39,365.17,109.16,369.43Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.83,382.5l-.19-4c.57,0,57.05-3,87.72-31.56,32-29.84,71-19,71.39-18.9l-1.11,3.84c-.37-.1-37.21-10.27-67.55,18C161.33,379.44,105.21,382.39,102.83,382.5Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.73,
    y: 343.19,
    width: 52.01,
    height: 39.69,
    rx: 2.39,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.73,
    y: 343.19,
    width: 52.01,
    height: 39.69,
    rx: 2.39,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.3,375.49H93.17a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h7.13a.5.5,0,0,1,.5.5A.5.5,0,0,1,100.3,375.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,372.84H88.43a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H105a.5.5,0,0,1,.5.5A.5.5,0,0,1,105,372.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.29,370.18H86.19a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h21.1a.5.5,0,0,1,.5.5A.5.5,0,0,1,107.29,370.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.55,367.53H84.92a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h23.63a.5.5,0,0,1,.5.5A.5.5,0,0,1,108.55,367.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.13,364.87H84.34a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h24.79a.5.5,0,0,1,.5.5A.5.5,0,0,1,109.13,364.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.13,362.22H84.34a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h24.79a.5.5,0,0,1,.5.5A.5.5,0,0,1,109.13,362.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.55,359.56H84.93a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h23.62a.5.5,0,0,1,.5.5A.5.5,0,0,1,108.55,359.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.29,356.91H86.19a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h21.1a.5.5,0,0,1,.5.5A.5.5,0,0,1,107.29,356.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,354.25H88.43a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H105a.5.5,0,0,1,.5.5A.5.5,0,0,1,105,354.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.3,351.6H93.17a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h7.13a.5.5,0,0,1,.5.5A.5.5,0,0,1,100.3,351.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.73,
    y: 343.19,
    width: 52.01,
    height: 39.69,
    rx: 2.39,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.73,
    y: 343.19,
    width: 52.01,
    height: 39.69,
    rx: 2.39,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.3,375.49h-7.13a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h7.13a.5.5,0,0,1,.5.5A.5.5,0,0,1,180.3,375.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,372.84H168.43a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H185a.5.5,0,0,1,.5.5A.5.5,0,0,1,185,372.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.29,370.18h-21.1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h21.1a.5.5,0,0,1,.5.5A.5.5,0,0,1,187.29,370.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.55,367.53H164.92a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h23.63a.5.5,0,0,1,.5.5A.5.5,0,0,1,188.55,367.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.13,364.87H164.34a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h24.79a.5.5,0,0,1,.5.5A.5.5,0,0,1,189.13,364.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.13,362.22H164.34a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h24.79a.5.5,0,0,1,.5.5A.5.5,0,0,1,189.13,362.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.55,359.56H164.93a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h23.62a.5.5,0,0,1,.5.5A.5.5,0,0,1,188.55,359.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.29,356.91h-21.1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h21.1a.5.5,0,0,1,.5.5A.5.5,0,0,1,187.29,356.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,354.25H168.43a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H185a.5.5,0,0,1,.5.5A.5.5,0,0,1,185,354.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.3,351.6h-7.13a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h7.13a.5.5,0,0,1,.5.5A.5.5,0,0,1,180.3,351.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.78,
    y: 135.82,
    width: 183.61,
    height: 246.59,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.82,
    y: 135.82,
    width: 183.61,
    height: 246.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.67,
    y: 139,
    width: 176.23,
    height: 243.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.75,
    y: 363.1,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.75,
    y: 363.1,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.34,
    y: 363.1,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.46,369.31a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,279.46,369.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.85,
    cy: 369.31,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.29,
    y: 367.83,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.75,
    y: 349.54,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.75,
    y: 349.54,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.34,
    y: 349.54,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.85,
    cy: 355.75,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.85,
    cy: 355.75,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.29,
    y: 354.27,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.75,
    y: 335.98,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.75,
    y: 335.98,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.34,
    y: 335.98,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.46,342.19a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,279.46,342.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.18,342.19a1.33,1.33,0,1,1-1.33-1.32A1.32,1.32,0,0,1,278.18,342.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.29,
    y: 340.71,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.75,
    y: 322.42,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.75,
    y: 322.42,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.34,
    y: 322.42,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.85,
    cy: 328.63,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.85,
    cy: 328.63,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.29,
    y: 327.15,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.83,
    y: 308.86,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.83,
    y: 308.86,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.42,
    y: 308.86,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.94,
    cy: 315.07,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.94,
    cy: 315.07,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.38,
    y: 313.59,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.92,
    y: 295.3,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.92,
    y: 295.3,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.51,
    y: 295.3,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.63,301.51A2.61,2.61,0,1,1,277,298.9,2.61,2.61,0,0,1,279.63,301.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.02,
    cy: 301.51,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.46,
    y: 300.03,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 281.74,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 281.74,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.6,
    y: 281.74,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.72,288a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,279.72,288Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.11,
    cy: 287.95,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.55,
    y: 286.47,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.09,
    y: 268.18,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.09,
    y: 268.18,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.68,
    y: 268.18,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.8,274.39a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,279.8,274.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.52,274.39a1.33,1.33,0,1,1-1.33-1.33A1.33,1.33,0,0,1,278.52,274.39Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.63,
    y: 272.91,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 254.62,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 254.62,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.77,
    y: 254.62,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.28,
    cy: 260.83,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.61,260.83a1.33,1.33,0,1,1-1.33-1.33A1.34,1.34,0,0,1,278.61,260.83Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.72,
    y: 259.35,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.26,
    y: 241.06,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.26,
    y: 241.06,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.85,
    y: 241.06,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.37,
    cy: 247.27,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.37,
    cy: 247.27,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 245.79,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.35,
    y: 227.5,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.35,
    y: 227.5,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.94,
    y: 227.5,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.45,
    cy: 233.71,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.45,
    cy: 233.71,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.89,
    y: 232.22,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.43,
    y: 213.94,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.43,
    y: 213.94,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.02,
    y: 213.94,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.15,220.15a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,280.15,220.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.54,
    cy: 220.15,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.98,
    y: 218.66,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.52,
    y: 200.38,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.52,
    y: 200.38,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.11,
    y: 200.38,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.23,206.59a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,280.23,206.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.62,
    cy: 206.59,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.06,
    y: 205.1,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.6,
    y: 186.82,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.6,
    y: 186.82,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.19,
    y: 186.82,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.32,193a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,280.32,193Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,193a1.33,1.33,0,1,1-1.32-1.33A1.33,1.33,0,0,1,279,193Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.15,
    y: 191.54,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.69,
    y: 173.26,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.69,
    y: 173.26,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.28,
    y: 173.26,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.79,
    cy: 179.47,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.12,179.47a1.33,1.33,0,1,1-1.33-1.33A1.33,1.33,0,0,1,279.12,179.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.23,
    y: 177.98,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.77,
    y: 159.7,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.77,
    y: 159.7,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.36,
    y: 159.7,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.88,
    cy: 165.91,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.21,165.91a1.33,1.33,0,1,1-1.33-1.33A1.33,1.33,0,0,1,279.21,165.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.32,
    y: 164.42,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.86,
    y: 146.14,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.86,
    y: 146.14,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.45,
    y: 146.14,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.96,
    cy: 152.35,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.96,
    cy: 152.35,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.4,
    y: 150.86,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.18,
    y: 363.1,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.18,
    y: 363.1,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.77,
    y: 363.1,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.89,369.31a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,331.89,369.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.61,369.31a1.33,1.33,0,1,1-1.33-1.32A1.33,1.33,0,0,1,330.61,369.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.72,
    y: 367.83,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.18,
    y: 349.54,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.18,
    y: 349.54,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.77,
    y: 349.54,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.28,
    cy: 355.75,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.61,355.75a1.33,1.33,0,1,1-1.33-1.32A1.33,1.33,0,0,1,330.61,355.75Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.72,
    y: 354.27,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.18,
    y: 335.98,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.18,
    y: 335.98,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.77,
    y: 335.98,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.89,342.19a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,331.89,342.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.61,342.19a1.33,1.33,0,1,1-1.33-1.32A1.33,1.33,0,0,1,330.61,342.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.72,
    y: 340.71,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.18,
    y: 322.42,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.18,
    y: 322.42,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.77,
    y: 322.42,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.28,
    cy: 328.63,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.61,328.63a1.33,1.33,0,1,1-1.33-1.33A1.33,1.33,0,0,1,330.61,328.63Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.72,
    y: 327.15,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.26,
    y: 308.86,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.26,
    y: 308.86,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.85,
    y: 308.86,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.37,
    cy: 315.07,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.37,
    cy: 315.07,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.81,
    y: 313.59,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.35,
    y: 295.3,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.35,
    y: 295.3,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.94,
    y: 295.3,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.45,
    cy: 301.51,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.45,
    cy: 301.51,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.89,
    y: 300.03,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.43,
    y: 281.74,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.43,
    y: 281.74,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.02,
    y: 281.74,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.15,288a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,332.15,288Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.54,
    cy: 287.95,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.98,
    y: 286.47,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.52,
    y: 268.18,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.52,
    y: 268.18,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.11,
    y: 268.18,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.23,274.39a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,332.23,274.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.62,
    cy: 274.39,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.06,
    y: 272.91,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.6,
    y: 254.62,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.6,
    y: 254.62,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.2,
    y: 254.62,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.32,260.83a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,332.32,260.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,260.83a1.33,1.33,0,1,1-1.33-1.33A1.34,1.34,0,0,1,331,260.83Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.15,
    y: 259.35,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.69,
    y: 241.06,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.69,
    y: 241.06,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.28,
    y: 241.06,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.79,
    cy: 247.27,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.12,247.27a1.33,1.33,0,1,1-1.33-1.33A1.33,1.33,0,0,1,331.12,247.27Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 245.79,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.77,
    y: 227.5,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.77,
    y: 227.5,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.37,
    y: 227.5,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.88,
    cy: 233.71,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.88,
    cy: 233.71,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.32,
    y: 232.22,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.86,
    y: 213.94,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.86,
    y: 213.94,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.45,
    y: 213.94,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.97,
    cy: 220.15,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.97,
    cy: 220.15,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 218.66,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.95,
    y: 200.38,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.95,
    y: 200.38,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.54,
    y: 200.38,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.66,206.59a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,332.66,206.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.05,
    cy: 206.59,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.49,
    y: 205.1,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.03,
    y: 186.82,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.03,
    y: 186.82,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.62,
    y: 186.82,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.75,193a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,332.75,193Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.14,
    cy: 193.03,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.58,
    y: 191.54,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.12,
    y: 173.26,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.12,
    y: 173.26,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.71,
    y: 173.26,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.83,179.47a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,332.83,179.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.55,179.47a1.33,1.33,0,1,1-1.33-1.33A1.34,1.34,0,0,1,331.55,179.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.66,
    y: 177.98,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.2,
    y: 159.7,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.2,
    y: 159.7,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.79,
    y: 159.7,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.92,165.91a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,332.92,165.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.63,165.91a1.33,1.33,0,1,1-1.32-1.33A1.32,1.32,0,0,1,331.63,165.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.75,
    y: 164.42,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.29,
    y: 146.14,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.29,
    y: 146.14,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.88,
    y: 146.14,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.39,
    cy: 152.35,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.72,152.35a1.33,1.33,0,1,1-1.33-1.33A1.32,1.32,0,0,1,331.72,152.35Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.83,
    y: 150.86,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.61,
    y: 363.1,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.61,
    y: 363.1,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.2,
    y: 363.1,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.32,369.31a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,384.32,369.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,369.31a1.33,1.33,0,1,1-1.33-1.32A1.33,1.33,0,0,1,383,369.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.15,
    y: 367.83,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.61,
    y: 349.54,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.61,
    y: 349.54,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.2,
    y: 349.54,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.32,355.75a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,384.32,355.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,355.75a1.33,1.33,0,1,1-1.33-1.32A1.33,1.33,0,0,1,383,355.75Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.15,
    y: 354.27,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.61,
    y: 335.98,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.61,
    y: 335.98,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.2,
    y: 335.98,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.32,342.19a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,384.32,342.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,342.19a1.33,1.33,0,1,1-1.33-1.32A1.33,1.33,0,0,1,383,342.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.15,
    y: 340.71,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.61,
    y: 322.42,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.61,
    y: 322.42,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.2,
    y: 322.42,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.32,328.63a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,384.32,328.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,328.63a1.33,1.33,0,1,1-1.33-1.33A1.33,1.33,0,0,1,383,328.63Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.15,
    y: 327.15,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.69,
    y: 308.86,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.69,
    y: 308.86,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.28,
    y: 308.86,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.8,
    cy: 315.07,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.12,315.07a1.33,1.33,0,1,1-1.32-1.33A1.32,1.32,0,0,1,383.12,315.07Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.24,
    y: 313.59,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.78,
    y: 295.3,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.78,
    y: 295.3,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.37,
    y: 295.3,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.88,
    cy: 301.51,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.88,
    cy: 301.51,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.32,
    y: 300.03,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.86,
    y: 281.74,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.86,
    y: 281.74,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.45,
    y: 281.74,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.97,
    cy: 287.95,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.97,
    cy: 287.95,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.41,
    y: 286.47,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.95,
    y: 268.18,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.95,
    y: 268.18,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.54,
    y: 268.18,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.66,274.39a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,384.66,274.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.05,
    cy: 274.39,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.49,
    y: 272.91,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.03,
    y: 254.62,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.03,
    y: 254.62,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.62,
    y: 254.62,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.75,260.83a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,384.75,260.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.14,
    cy: 260.83,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.58,
    y: 259.35,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.12,
    y: 241.06,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.12,
    y: 241.06,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.71,
    y: 241.06,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.83,247.27a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,384.83,247.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.55,247.27a1.33,1.33,0,1,1-1.33-1.33A1.33,1.33,0,0,1,383.55,247.27Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.66,
    y: 245.79,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.2,
    y: 227.5,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.2,
    y: 227.5,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.8,
    y: 227.5,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.31,
    cy: 233.71,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.64,233.71a1.33,1.33,0,1,1-1.33-1.33A1.34,1.34,0,0,1,383.64,233.71Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.75,
    y: 232.22,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.29,
    y: 213.94,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.29,
    y: 213.94,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.88,
    y: 213.94,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.39,
    cy: 220.15,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.72,220.15a1.33,1.33,0,1,1-1.33-1.33A1.33,1.33,0,0,1,383.72,220.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.83,
    y: 218.66,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.37,
    y: 200.38,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.37,
    y: 200.38,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.97,
    y: 200.38,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.48,
    cy: 206.59,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.48,
    cy: 206.59,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.92,
    y: 205.1,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.46,
    y: 186.82,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.46,
    y: 186.82,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.05,
    y: 186.82,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.57,
    cy: 193.03,
    r: 2.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.57,
    cy: 193.03,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374,
    y: 191.54,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.55,
    y: 173.26,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.55,
    y: 173.26,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.14,
    y: 173.26,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.26,179.47a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,385.26,179.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.65,
    cy: 179.47,
    r: 1.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.09,
    y: 177.98,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.63,
    y: 159.7,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.63,
    y: 159.7,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.22,
    y: 159.7,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.35,165.91a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,385.35,165.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.06,165.91a1.33,1.33,0,1,1-1.32-1.33A1.32,1.32,0,0,1,384.06,165.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.18,
    y: 164.42,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.72,
    y: 146.14,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.72,
    y: 146.14,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.31,
    y: 146.14,
    width: 42.3,
    height: 12.42,
    rx: 1.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.43,152.35a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,385.43,152.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.15,152.35a1.33,1.33,0,1,1-1.33-1.33A1.33,1.33,0,0,1,384.15,152.35Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.26,
    y: 150.86,
    width: 2.97,
    height: 2.97,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-3",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Code--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.11,152.45a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.59,1.59,0,0,1-1.19-.49,1.62,1.62,0,0,1-.5-1.19v-3.84a1.6,1.6,0,0,1,.5-1.19,1.63,1.63,0,0,1,1.19-.5,1.6,1.6,0,0,1,1.19.5,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.63.63,0,0,0-.43-.17.6.6,0,0,0-.43.17.6.6,0,0,0-.18.44v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.73,136.35a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.67,1.67,0,0,1-1.68-1.68v-3.84a1.59,1.59,0,0,1,.49-1.19,1.63,1.63,0,0,1,1.19-.5,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.6.6,0,0,0,.18.43.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.67,152.45a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.63,1.63,0,0,1,1.19-.5,1.6,1.6,0,0,1,1.19.5,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.63.63,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.4,86.36V80.94h-.91v-.75a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,125.07a1.68,1.68,0,0,1-2.88,1.18,1.59,1.59,0,0,1-.49-1.18v-3.85a1.67,1.67,0,0,1,1.68-1.68,1.63,1.63,0,0,1,1.2.49,1.66,1.66,0,0,1,.49,1.19Zm-1.11-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56,154.06v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.92,152.45a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.63,1.63,0,0,1,1.19-.5,1.6,1.6,0,0,1,1.19.5,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.63.63,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69,154.06v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.05,152.45a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.61,1.61,0,0,1-.49-1.19v-3.84a1.71,1.71,0,0,1,1.69-1.69,1.63,1.63,0,0,1,1.19.5,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.64.64,0,0,0-.44-.17.61.61,0,0,0-.43.17.6.6,0,0,0-.17.44v3.85a.57.57,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.12,139.32V133.9h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.43,1.43,0,0,0,.5-.6h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.17,152.45a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.67,1.67,0,0,1-1.68-1.68v-3.84a1.59,1.59,0,0,1,.49-1.19,1.63,1.63,0,0,1,1.19-.5,1.6,1.6,0,0,1,1.19.5,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.63.63,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.94,154.06v-5.42H145v-.74a1.58,1.58,0,0,0,.73-.29,1.51,1.51,0,0,0,.5-.6H147v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.3,152.45a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.61,1.61,0,0,1-.49-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.68,1.68,0,0,1,2.39,0,1.66,1.66,0,0,1,.49,1.19Zm-1.11-3.86a.6.6,0,0,0-.18-.44.63.63,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.16,113.35v-5.42h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.75v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.42,152.45a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.59,1.59,0,0,1-1.19-.49,1.62,1.62,0,0,1-.5-1.19v-3.84a1.6,1.6,0,0,1,.5-1.19,1.63,1.63,0,0,1,1.19-.5,1.6,1.6,0,0,1,1.19.5,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.63.63,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.18,154.06v-5.42h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.51,1.51,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.55,152.45a1.69,1.69,0,0,1-1.69,1.68,1.67,1.67,0,0,1-1.68-1.68v-3.84a1.59,1.59,0,0,1,.49-1.19,1.68,1.68,0,0,1,2.39,0,1.66,1.66,0,0,1,.49,1.19Zm-1.11-3.86a.6.6,0,0,0-.18-.44.63.63,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.59,139.32V133.9h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.43,1.43,0,0,0,.5-.6h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.67,152.45a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.59,1.59,0,0,1-1.19-.49,1.62,1.62,0,0,1-.5-1.19v-3.84a1.6,1.6,0,0,1,.5-1.19,1.63,1.63,0,0,1,1.19-.5,1.6,1.6,0,0,1,1.19.5,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44A.63.63,0,0,0,171,148a.6.6,0,0,0-.43.17.6.6,0,0,0-.18.44v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.93,98.87V93.45H168v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59H170v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.8,75.63V70.21h-.9v-.75a1.5,1.5,0,0,0,.73-.28,1.47,1.47,0,0,0,.49-.6h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.25,123.23a1.62,1.62,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.62,1.62,0,0,1-1.19-.5,1.59,1.59,0,0,1-.49-1.18v-3.85a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.08,152.45a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.61,1.61,0,0,1-.49-1.19v-3.84a1.68,1.68,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19ZM183,148.59a.6.6,0,0,0-.18-.44.63.63,0,0,0-.86,0,.6.6,0,0,0-.17.44v3.85a.57.57,0,0,0,.17.43.61.61,0,0,0,1-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.36,152.45a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.65,1.65,0,0,1-.49-1.19v-3.84a1.68,1.68,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.64.64,0,0,0-.44-.17.63.63,0,0,0-.43.17.64.64,0,0,0-.17.44v3.85a.61.61,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.64,152.45a1.67,1.67,0,0,1-1.68,1.68,1.59,1.59,0,0,1-1.19-.49,1.62,1.62,0,0,1-.5-1.19v-3.84a1.68,1.68,0,0,1,2.88-1.19,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.63.63,0,0,0-.43-.17.6.6,0,0,0-.43.17.6.6,0,0,0-.18.44v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,108.23a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.67,1.67,0,0,1-1.68-1.68v-3.84a1.63,1.63,0,0,1,.49-1.2,1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.2,152.45a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.63,1.63,0,0,1,1.19-.5,1.6,1.6,0,0,1,1.19.5,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.63.63,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.54,121.46a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.67,1.67,0,0,1-1.68-1.68v-3.84a1.63,1.63,0,0,1,.49-1.2,1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.25,154.06v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.09,154.06v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.92,154.06v-5.42H212v-.74a1.63,1.63,0,0,0,.73-.29,1.41,1.41,0,0,0,.49-.6H214v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,124.83V119.4h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.48,1.48,0,0,0,.5-.59H216v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.6,154.06v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.44,154.06v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.51,1.51,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.92,132.75a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.69-1.68V128.9a1.63,1.63,0,0,1,.5-1.19,1.69,1.69,0,0,1,2.38,0,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.08,152.45a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.65,1.65,0,0,1-.49-1.19v-3.84a1.68,1.68,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.64.64,0,0,0-.44-.17.63.63,0,0,0-.43.17.64.64,0,0,0-.17.44v3.85a.61.61,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.84,154.06v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.36,1.36,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.77,310.16v-5.43h-.91V304a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.61,310.16v-5.43H71.7V304a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.25,308.55a1.69,1.69,0,0,1-2.88,1.19,1.66,1.66,0,0,1-.49-1.19v-3.84a1.64,1.64,0,0,1,.5-1.2,1.61,1.61,0,0,1,1.19-.49,1.65,1.65,0,0,1,1.19.49,1.63,1.63,0,0,1,.49,1.2Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.64.64,0,0,0,.17.44.6.6,0,0,0,.43.18.61.61,0,0,0,.62-.62Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,310.16v-5.43h-.9V304a1.52,1.52,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.71,117.86a1.62,1.62,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.71,1.71,0,0,1-1.69-1.68V114a1.69,1.69,0,0,1,1.69-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.89,158.39V153H76v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59H78v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.46,147.72a1.62,1.62,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.69,1.69,0,0,1-1.69-1.68v-3.85a1.69,1.69,0,0,1,1.69-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.43-.18.57.57,0,0,0-.43.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.29,194a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.59,1.59,0,0,1-1.19-.49,1.62,1.62,0,0,1-.5-1.19V190.2a1.6,1.6,0,0,1,.5-1.19,1.63,1.63,0,0,1,1.19-.5,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.58.58,0,0,0-.43-.18.57.57,0,0,0-.43.18.6.6,0,0,0-.18.44V194a.6.6,0,0,0,.18.43.57.57,0,0,0,.43.18.58.58,0,0,0,.43-.18.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.57,194a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19V190.2a1.59,1.59,0,0,1,.49-1.19,1.63,1.63,0,0,1,1.19-.5,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44V194a.6.6,0,0,0,.18.43.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.34,195.65v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.7,194a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.61,1.61,0,0,1-.49-1.19V190.2a1.71,1.71,0,0,1,1.69-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.61.61,0,0,0-.62-.62.58.58,0,0,0-.43.18.6.6,0,0,0-.17.44V194a.59.59,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.46,195.65v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.82,194a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19V190.2A1.59,1.59,0,0,1,130,189a1.63,1.63,0,0,1,1.19-.5,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44V194a.6.6,0,0,0,.18.43.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.59,195.65v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.51,1.51,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,194a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.61,1.61,0,0,1-.49-1.19V190.2a1.68,1.68,0,0,1,2.88-1.19,1.65,1.65,0,0,1,.49,1.19Zm-1.11-3.86a.6.6,0,0,0-.18-.44.57.57,0,0,0-.43-.18.58.58,0,0,0-.43.18.6.6,0,0,0-.17.44V194a.59.59,0,0,0,.17.43.58.58,0,0,0,.43.18.57.57,0,0,0,.43-.18.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.3,175.63v-5.42h-.9v-.75a1.49,1.49,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.66,174a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49A1.67,1.67,0,0,1,270.3,174v-3.84a1.63,1.63,0,0,1,.49-1.2,1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44V174a.6.6,0,0,0,.18.44.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.43,175.63v-5.42h-.91v-.75a1.61,1.61,0,0,0,1.23-.88h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.79,174a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.61,1.61,0,0,1-.49-1.19v-3.84a1.63,1.63,0,0,1,.49-1.2,1.67,1.67,0,0,1,1.2-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.11-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44V174a.6.6,0,0,0,.18.44.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.6,175.07a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19v-3.84a1.63,1.63,0,0,1,.49-1.2,1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.6.6,0,0,0,.18.43.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.42,125.78a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.61,1.61,0,0,1-.49-1.19v-3.84a1.69,1.69,0,1,1,3.37,0Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.59.59,0,0,0-.17.43v3.85a.6.6,0,0,0,.17.44.58.58,0,0,0,.43.18.61.61,0,0,0,.62-.62Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.52,195.65v-5.42h-.9v-.74a1.67,1.67,0,0,0,.73-.29,1.41,1.41,0,0,0,.49-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.36,195.65v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.2,195.65v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,195.65v-5.42h-.9v-.74a1.58,1.58,0,0,0,.73-.29,1.51,1.51,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.87,195.65v-5.42H175v-.74a1.63,1.63,0,0,0,.73-.29,1.41,1.41,0,0,0,.49-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.23,194a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19V190.2a1.59,1.59,0,0,1,.49-1.19,1.63,1.63,0,0,1,1.19-.5,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44V194a.6.6,0,0,0,.18.43.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,195.65v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.36,194a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49A1.65,1.65,0,0,1,185,194V190.2a1.68,1.68,0,0,1,2.88-1.19,1.65,1.65,0,0,1,.49,1.19Zm-1.1-3.86a.61.61,0,0,0-.62-.62.58.58,0,0,0-.43.18.64.64,0,0,0-.17.44V194a.63.63,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.12,195.65v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,91.2a1.67,1.67,0,0,1-1.68,1.68,1.65,1.65,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19V87.35a1.67,1.67,0,0,1,1.68-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.25,195.65v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.61,194a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.61,1.61,0,0,1-.49-1.19V190.2a1.71,1.71,0,0,1,1.69-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.61.61,0,0,0-.62-.62.58.58,0,0,0-.43.18.6.6,0,0,0-.17.44V194a.59.59,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.89,194a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.65,1.65,0,0,1-.49-1.19V190.2A1.68,1.68,0,0,1,206.4,189a1.65,1.65,0,0,1,.49,1.19Zm-1.1-3.86a.61.61,0,0,0-.62-.62.6.6,0,0,0-.43.18.64.64,0,0,0-.17.44V194a.63.63,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.17,194a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.59,1.59,0,0,1-1.19-.49,1.62,1.62,0,0,1-.5-1.19V190.2a1.6,1.6,0,0,1,.5-1.19,1.63,1.63,0,0,1,1.19-.5,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.43-.18.57.57,0,0,0-.43.18.6.6,0,0,0-.18.44V194a.6.6,0,0,0,.18.43.57.57,0,0,0,.43.18.61.61,0,0,0,.61-.61Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.45,194a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.67,1.67,0,0,1-1.68-1.68V190.2a1.59,1.59,0,0,1,.49-1.19,1.63,1.63,0,0,1,1.19-.5,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44V194a.6.6,0,0,0,.18.43.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.22,195.65v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.05,195.65v-5.42h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.41,1.41,0,0,0,.49-.6h.75v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.89,195.65v-5.42H222v-.74a1.59,1.59,0,0,0,.72-.29,1.43,1.43,0,0,0,.5-.6H224v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.75,152.46a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19v-3.84a1.63,1.63,0,0,1,.49-1.2,1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.84a.6.6,0,0,0,.18.44.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08,187.91v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.44,1.44,0,0,0,.5-.6h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.44,186.3a1.69,1.69,0,0,1-2.88,1.19,1.61,1.61,0,0,1-.49-1.19v-3.84a1.68,1.68,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.11-3.86a.58.58,0,0,0-.18-.43.57.57,0,0,0-.43-.18.58.58,0,0,0-.43.18.57.57,0,0,0-.17.43v3.85a.57.57,0,0,0,.17.43.58.58,0,0,0,.43.18.57.57,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.2,187.91v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.37,1.37,0,0,0,.5-.6h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.64,237.39V232h-.91v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.34,232.83a1.69,1.69,0,1,1-3.37,0V229a1.69,1.69,0,0,1,2.88-1.2,1.67,1.67,0,0,1,.49,1.2ZM79.23,229A.61.61,0,0,0,78,229v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.78,209.51v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.14,207.9a1.67,1.67,0,0,1-1.68,1.69,1.71,1.71,0,0,1-1.69-1.69v-3.84a1.69,1.69,0,0,1,2.88-1.19,1.62,1.62,0,0,1,.49,1.19ZM116,204a.58.58,0,0,0-.18-.43.6.6,0,0,0-.43-.18.57.57,0,0,0-.43.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.42,207.9a1.63,1.63,0,0,1-.49,1.2,1.66,1.66,0,0,1-1.19.49,1.69,1.69,0,0,1-1.68-1.69v-3.84a1.59,1.59,0,0,1,.49-1.19,1.62,1.62,0,0,1,1.19-.49,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.7,207.9a1.63,1.63,0,0,1-.49,1.2,1.66,1.66,0,0,1-1.19.49,1.62,1.62,0,0,1-1.19-.5,1.59,1.59,0,0,1-.49-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.62,1.62,0,0,1,1.19-.49,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19ZM124.6,204a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.47,209.51v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.83,207.9a1.69,1.69,0,1,1-3.37,0v-3.84a1.69,1.69,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.86a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.59,209.51v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,227.9a1.63,1.63,0,0,1-.49,1.2,1.66,1.66,0,0,1-1.19.49,1.62,1.62,0,0,1-1.19-.5,1.59,1.59,0,0,1-.49-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.62,1.62,0,0,1,1.19-.49,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.72,229.51v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.08,227.9a1.68,1.68,0,0,1-2.88,1.19,1.59,1.59,0,0,1-.49-1.19v-3.84a1.69,1.69,0,0,1,1.69-1.68,1.62,1.62,0,0,1,1.19.49,1.66,1.66,0,0,1,.49,1.19ZM146,224a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.57.57,0,0,0-.17.43v3.85a.57.57,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.84,229.51v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.2,227.9a1.63,1.63,0,0,1-.49,1.2,1.66,1.66,0,0,1-1.19.49,1.69,1.69,0,0,1-1.68-1.69v-3.84a1.59,1.59,0,0,1,.49-1.19,1.62,1.62,0,0,1,1.19-.49,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19ZM153.1,224a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.47,250.8A1.61,1.61,0,0,1,129,252a1.66,1.66,0,0,1-1.19.49,1.65,1.65,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19V247a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.76,227.9a1.63,1.63,0,0,1-.49,1.2,1.68,1.68,0,0,1-2.38,0,1.59,1.59,0,0,1-.49-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.7,1.7,0,0,1,2.39,0,1.65,1.65,0,0,1,.48,1.19Zm-1.1-3.86a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.05,227.9a1.68,1.68,0,0,1-2.88,1.19,1.59,1.59,0,0,1-.49-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.7,1.7,0,0,1,2.39,0,1.66,1.66,0,0,1,.49,1.19ZM165.94,224a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.33,227.9a1.69,1.69,0,1,1-3.37,0v-3.84a1.69,1.69,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.86a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.61,227.9a1.69,1.69,0,0,1-1.68,1.69,1.71,1.71,0,0,1-1.69-1.69v-3.84a1.69,1.69,0,0,1,2.88-1.19,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.58.58,0,0,0-.18-.43.6.6,0,0,0-.43-.18.57.57,0,0,0-.43.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.89,227.9a1.63,1.63,0,0,1-.49,1.2,1.66,1.66,0,0,1-1.19.49,1.69,1.69,0,0,1-1.68-1.69v-3.84a1.59,1.59,0,0,1,.49-1.19,1.62,1.62,0,0,1,1.19-.49,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.65,209.51v-5.42h-.9v-.74a1.58,1.58,0,0,0,.73-.29,1.48,1.48,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.49,209.51v-5.42h-.9v-.74a1.67,1.67,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.33,209.51v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.17,209.51v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,209.51v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.48,1.48,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.84,209.51v-5.42h-.9v-.74a1.67,1.67,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.2,207.9a1.63,1.63,0,0,1-.49,1.2,1.66,1.66,0,0,1-1.19.49,1.62,1.62,0,0,1-1.19-.5,1.59,1.59,0,0,1-.49-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.62,1.62,0,0,1,1.19-.49,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19ZM200.1,204a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.48,207.9a1.63,1.63,0,0,1-.49,1.2,1.66,1.66,0,0,1-1.19.49,1.63,1.63,0,0,1-1.19-.5,1.59,1.59,0,0,1-.49-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.7,1.7,0,0,1,2.39,0,1.65,1.65,0,0,1,.48,1.19Zm-1.1-3.86a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.25,209.51v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.61,207.9a1.69,1.69,0,1,1-3.37,0v-3.84a1.69,1.69,0,0,1,2.88-1.19,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.56.56,0,0,0-.42.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.56.56,0,0,0,.42.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.37,209.51v-5.42h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.75v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.21,209.51v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.05,209.51v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.89,209.51v-5.42H222v-.74a1.58,1.58,0,0,0,.73-.29,1.48,1.48,0,0,0,.5-.59H224v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,207.9a1.68,1.68,0,0,1-2.88,1.19,1.59,1.59,0,0,1-.49-1.19v-3.84a1.69,1.69,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19ZM227.14,204a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,209.51v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.37,207.9a1.63,1.63,0,0,1-.49,1.2,1.66,1.66,0,0,1-1.19.49A1.71,1.71,0,0,1,232,207.9v-3.84a1.6,1.6,0,0,1,.5-1.19,1.62,1.62,0,0,1,1.19-.49,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.61.61,0,0,0-.61-.61.57.57,0,0,0-.43.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.61.61,0,0,0,.61-.61Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.13,209.51v-5.42h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.75v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.42,180.18a1.69,1.69,0,1,1-3.37,0v-3.84a1.67,1.67,0,0,1,.49-1.2,1.69,1.69,0,0,1,2.88,1.2Zm-1.11-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,87.89V82.47h-.91v-.75a1.61,1.61,0,0,0,1.23-.88h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.54,180.18a1.68,1.68,0,0,1-2.87,1.19,1.63,1.63,0,0,1-.5-1.19v-3.84a1.69,1.69,0,0,1,1.69-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.58.58,0,0,0-.43-.18.57.57,0,0,0-.43.18.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.56.56,0,0,0,.43.17.57.57,0,0,0,.43-.17.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.3,181.79v-5.43h-.9v-.74a1.52,1.52,0,0,0,.73-.29,1.48,1.48,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.08,209.6a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19v-3.84a1.63,1.63,0,0,1,.49-1.2,1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69ZM71,205.74a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.6.6,0,0,0,.18.43.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.43,181.79v-5.43h-.91v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.79,180.18a1.68,1.68,0,0,1-2.87,1.19,1.63,1.63,0,0,1-.5-1.19v-3.84a1.69,1.69,0,0,1,1.69-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.61.61,0,0,0-.61-.61.57.57,0,0,0-.43.18.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.56.56,0,0,0,.43.17.59.59,0,0,0,.43-.17.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.07,180.18a1.68,1.68,0,1,1-3.36,0v-3.84a1.67,1.67,0,0,1,1.68-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.35,180.18a1.68,1.68,0,1,1-3.36,0v-3.84a1.67,1.67,0,0,1,1.68-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.12,181.79v-5.43h-.91v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.48,180.18a1.69,1.69,0,0,1-2.88,1.19,1.66,1.66,0,0,1-.49-1.19v-3.84a1.64,1.64,0,0,1,.5-1.2,1.68,1.68,0,0,1,2.38,0,1.63,1.63,0,0,1,.49,1.19Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.63.63,0,0,0-.17.43v3.85a.64.64,0,0,0,.17.44.57.57,0,0,0,.43.17.6.6,0,0,0,.44-.17.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,181.79v-5.43h-.9v-.74a1.49,1.49,0,0,0,.72-.29,1.34,1.34,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.6,180.18a1.68,1.68,0,1,1-3.36,0v-3.84a1.67,1.67,0,0,1,1.68-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.53,186.89a1.62,1.62,0,0,1-.5,1.19,1.68,1.68,0,0,1-2.38,0,1.62,1.62,0,0,1-.49-1.18V183A1.69,1.69,0,0,1,54,181.85a1.66,1.66,0,0,1,.49,1.19ZM53.43,183a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.81,186.89a1.65,1.65,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.71,1.71,0,0,1-1.69-1.68V183a1.69,1.69,0,1,1,3.37,0ZM57.71,183a.58.58,0,0,0-.18-.43.6.6,0,0,0-.43-.18.57.57,0,0,0-.43.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.57,188.49v-5.42h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.75v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.93,186.89a1.61,1.61,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.63,1.63,0,0,1-1.19-.5,1.59,1.59,0,0,1-.49-1.18V183a1.67,1.67,0,0,1,1.68-1.68,1.63,1.63,0,0,1,1.2.49,1.65,1.65,0,0,1,.48,1.19ZM64.83,183a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7,188.49v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.06,186.89a1.62,1.62,0,0,1-.5,1.19,1.68,1.68,0,0,1-2.38,0,1.62,1.62,0,0,1-.49-1.18V183a1.69,1.69,0,1,1,3.37,0ZM72,183a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.56.56,0,0,0-.42.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.56.56,0,0,0,.42.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.37,181.79v-5.43h-.91v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.73,180.18a1.69,1.69,0,0,1-2.88,1.19,1.66,1.66,0,0,1-.49-1.19v-3.84a1.64,1.64,0,0,1,.5-1.2,1.61,1.61,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.63.63,0,0,0-.17.43v3.85a.64.64,0,0,0,.17.44.57.57,0,0,0,.43.17.6.6,0,0,0,.44-.17.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.49,181.79v-5.43h-.9v-.74a1.49,1.49,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.85,180.18a1.68,1.68,0,1,1-3.36,0v-3.84a1.67,1.67,0,0,1,1.68-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.13,180.18a1.68,1.68,0,1,1-3.36,0v-3.84a1.67,1.67,0,0,1,1.68-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.41,180.18a1.68,1.68,0,1,1-3.36,0v-3.84a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.7,180.18a1.69,1.69,0,1,1-3.37,0v-3.84a1.67,1.67,0,0,1,.49-1.2,1.69,1.69,0,0,1,2.88,1.2Zm-1.11-3.87a.6.6,0,0,0-.18-.43.57.57,0,0,0-.43-.18.58.58,0,0,0-.43.18.59.59,0,0,0-.17.43v3.85a.6.6,0,0,0,.17.44.57.57,0,0,0,.43.17.56.56,0,0,0,.43-.17.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.21,245.83a1.67,1.67,0,0,1-1.68,1.68,1.66,1.66,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19V242a1.69,1.69,0,0,1,2.88-1.2,1.66,1.66,0,0,1,.48,1.2Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.26,180.18a1.65,1.65,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.59,1.59,0,0,1-1.19-.49,1.63,1.63,0,0,1-.5-1.19v-3.84a1.64,1.64,0,0,1,.5-1.2,1.69,1.69,0,0,1,2.87,1.2Zm-1.1-3.87a.61.61,0,0,0-.61-.61.57.57,0,0,0-.43.18.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.56.56,0,0,0,.43.17.59.59,0,0,0,.43-.17.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.54,180.18a1.68,1.68,0,1,1-3.36,0v-3.84a1.67,1.67,0,0,1,1.68-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.31,181.79v-5.43h-.91v-.74a1.61,1.61,0,0,0,1.23-.88h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.14,181.79v-5.43h-.9v-.74a1.52,1.52,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,181.79v-5.43h-.9v-.74a1.49,1.49,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59H199v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.82,181.79v-5.43h-.91v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.49,141.56v-5.43h-.91v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.49,181.79v-5.43h-.9v-.74a1.56,1.56,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.85,180.18a1.68,1.68,0,1,1-3.36,0v-3.84a1.67,1.67,0,0,1,1.68-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.13,180.18a1.68,1.68,0,1,1-3.36,0v-3.84a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.9,181.79v-5.43H217v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59H219v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.26,180.18a1.69,1.69,0,0,1-1.68,1.68,1.59,1.59,0,0,1-1.19-.49,1.63,1.63,0,0,1-.5-1.19v-3.84a1.64,1.64,0,0,1,.5-1.2,1.69,1.69,0,0,1,2.87,1.2Zm-1.1-3.87a.61.61,0,0,0-.61-.61.57.57,0,0,0-.43.18.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.56.56,0,0,0,.43.17.59.59,0,0,0,.43-.17.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,181.79v-5.43h-.9v-.74a1.52,1.52,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.75v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.46,160.1v-5.43h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.7,181.79v-5.43h-.91v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.54,181.79v-5.43h-.91v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.9,180.18a1.69,1.69,0,1,1-3.37,0v-3.84a1.67,1.67,0,0,1,.49-1.2,1.69,1.69,0,0,1,2.88,1.2Zm-1.11-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.45,284.77a1.67,1.67,0,0,1-1.68,1.68,1.65,1.65,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19v-3.84a1.67,1.67,0,0,1,1.68-1.69,1.59,1.59,0,0,1,1.19.49,1.63,1.63,0,0,1,.49,1.2Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.22,286.38V281h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.58,284.77a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.69-1.68v-3.84a1.64,1.64,0,0,1,.5-1.2,1.69,1.69,0,0,1,2.38,0,1.67,1.67,0,0,1,.49,1.2Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.57.57,0,0,0-.17.43v3.85a.57.57,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.34,286.38V281h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.66,221.77a1.67,1.67,0,0,1-1.68,1.68,1.66,1.66,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.69,1.69,0,0,1,2.88-1.19,1.65,1.65,0,0,1,.48,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.43,223.38V218h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,253.32a1.62,1.62,0,0,1-.5,1.19,1.68,1.68,0,0,1-2.38,0,1.59,1.59,0,0,1-.49-1.18v-3.85a1.61,1.61,0,0,1,.49-1.19,1.7,1.7,0,0,1,2.39,0,1.66,1.66,0,0,1,.49,1.19Zm-1.11-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.07,221.77a1.67,1.67,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.68-1.68v-3.85a1.67,1.67,0,0,1,1.68-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19ZM131,217.9a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.35,221.77a1.67,1.67,0,0,1-1.68,1.68,1.65,1.65,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.67,1.67,0,0,1,1.68-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.12,243.38V238h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.48,241.77a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.69-1.68v-3.85a1.63,1.63,0,0,1,.5-1.19,1.69,1.69,0,0,1,2.38,0,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,243.38V238h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.34,1.34,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.6,241.77a1.67,1.67,0,0,1-1.68,1.68,1.65,1.65,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.67,1.67,0,0,1,1.68-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.37,243.38V238h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.73,241.77a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.69-1.68v-3.85a1.63,1.63,0,0,1,.5-1.19,1.69,1.69,0,0,1,2.38,0,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.49,243.38V238h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.85,241.77a1.67,1.67,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.68-1.68v-3.85a1.67,1.67,0,0,1,1.68-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.16,272.89a1.69,1.69,0,1,1-3.37,0v-3.84a1.69,1.69,0,0,1,2.88-1.19,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.44,272.89a1.66,1.66,0,0,1-1.68,1.68,1.69,1.69,0,0,1-1.69-1.68v-3.84a1.69,1.69,0,0,1,2.88-1.19,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.58.58,0,0,0-.18-.43.6.6,0,0,0-.43-.18.57.57,0,0,0-.43.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.72,272.89a1.63,1.63,0,0,1-.49,1.2,1.65,1.65,0,0,1-1.19.48,1.67,1.67,0,0,1-1.68-1.68v-3.84a1.59,1.59,0,0,1,.49-1.19,1.62,1.62,0,0,1,1.19-.49,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.28,317.53a1.62,1.62,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.63,1.63,0,0,1-1.19-.5,1.59,1.59,0,0,1-.49-1.18v-3.85A1.67,1.67,0,0,1,164.6,312a1.63,1.63,0,0,1,1.2.49,1.65,1.65,0,0,1,.48,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.28,272.89a1.68,1.68,0,0,1-2.87,1.19,1.59,1.59,0,0,1-.49-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.7,1.7,0,0,1,2.39,0,1.65,1.65,0,0,1,.48,1.19Zm-1.1-3.86a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.57,272.89a1.69,1.69,0,0,1-2.88,1.19,1.59,1.59,0,0,1-.49-1.19v-3.84a1.69,1.69,0,0,1,1.69-1.68,1.62,1.62,0,0,1,1.19.49,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.86a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.57.57,0,0,0-.17.43v3.85a.57.57,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.31,223.38V218h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.48,1.48,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.14,223.38V218h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,223.38V218h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59H199v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.82,223.38V218h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.65,223.38V218h-.9v-.74a1.58,1.58,0,0,0,.73-.29,1.48,1.48,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.87,252.4V247H184v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.85,221.77a1.67,1.67,0,0,1-1.68,1.68A1.65,1.65,0,0,1,209,223a1.62,1.62,0,0,1-.49-1.19v-3.85a1.67,1.67,0,0,1,1.68-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.13,221.77a1.67,1.67,0,0,1-1.68,1.68,1.66,1.66,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.69,1.69,0,0,1,2.88-1.19,1.65,1.65,0,0,1,.48,1.19ZM215,217.9a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.9,223.38V218H217v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59H219v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.26,221.77a1.69,1.69,0,0,1-3.37,0v-3.85a1.63,1.63,0,0,1,.5-1.19,1.68,1.68,0,0,1,2.87,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.43-.18.57.57,0,0,0-.43.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,223.38V218h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.75v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.86,223.38V218H227v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11,292.48v-5.43h-.91v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.94,292.48v-5.43H252v-.74a1.52,1.52,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59H254v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.3,290.87a1.68,1.68,0,1,1-3.36,0V287a1.69,1.69,0,0,1,2.88-1.2,1.66,1.66,0,0,1,.48,1.2ZM257.2,287a.61.61,0,0,0-1.22,0v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.72,297.16a1.61,1.61,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.69,1.69,0,0,1-1.69-1.68v-3.85a1.69,1.69,0,0,1,1.69-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.43-.18.57.57,0,0,0-.43.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.88,167.92V162.5H108v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.24,166.32a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.69-1.68v-3.85a1.69,1.69,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.87A.58.58,0,0,0,113,162a.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,167.92V162.5h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7,177.63a1.62,1.62,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.69,1.69,0,0,1-1.68-1.68v-3.85a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.13,167.92V162.5h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.49,166.32a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.2-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.69,1.69,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.57.57,0,0,0-.17.43v3.85a.57.57,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.77,166.32a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.69-1.68v-3.85a1.69,1.69,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.11,93.75a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.59,1.59,0,0,1-1.19-.49,1.62,1.62,0,0,1-.5-1.19V89.91a1.64,1.64,0,0,1,.5-1.2,1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69ZM112,89.89a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.84a.6.6,0,0,0,.18.44.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.88,95.36V89.94H114v-.75a1.47,1.47,0,0,0,.73-.28,1.51,1.51,0,0,0,.5-.6h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.17,166.32a1.62,1.62,0,0,1-.49,1.19,1.69,1.69,0,0,1-2.38,0,1.62,1.62,0,0,1-.49-1.19v-3.85a1.67,1.67,0,0,1,1.68-1.68,1.63,1.63,0,0,1,1.2.49,1.65,1.65,0,0,1,.48,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.94,167.92V162.5H145v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59H147v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.93,140a1.61,1.61,0,0,1-.49,1.19,1.65,1.65,0,0,1-1.19.49,1.66,1.66,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.69,1.69,0,0,1,2.88-1.19,1.65,1.65,0,0,1,.48,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.7,141.56v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.06,140a1.61,1.61,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.69,1.69,0,0,1-1.69-1.68v-3.85a1.69,1.69,0,0,1,1.69-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.61.61,0,0,0-.61-.61.57.57,0,0,0-.43.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.61.61,0,0,0,.61-.61Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.82,141.56v-5.42h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.75v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.31,69.16a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.2-.49,1.62,1.62,0,0,1-.49-1.19V65.31a1.63,1.63,0,0,1,.5-1.19,1.59,1.59,0,0,1,1.19-.49,1.62,1.62,0,0,1,1.19.49,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.57.57,0,0,0-.17.43v3.85a.57.57,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.07,70.77V65.34h-.9V64.6a1.49,1.49,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.43,69.16a1.67,1.67,0,0,1-1.68,1.68,1.65,1.65,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19V65.31a1.67,1.67,0,0,1,1.68-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.2,70.77V65.34h-.91V64.6a1.61,1.61,0,0,0,1.23-.88h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.55,166.32a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.69-1.68v-3.85a1.69,1.69,0,1,1,3.37,0Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.31,167.92V162.5h-.9v-.74a1.67,1.67,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.67,166.32a1.62,1.62,0,0,1-.49,1.19A1.66,1.66,0,0,1,171,168a1.65,1.65,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.44,167.92V162.5h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.8,166.32a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.69-1.68v-3.85a1.69,1.69,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.56,167.92V162.5h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.92,166.32a1.62,1.62,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.65,1.65,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.69,167.92V162.5h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.05,166.32a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.2-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.69,1.69,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.57.57,0,0,0-.17.43v3.85a.57.57,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.81,167.92V162.5h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.17,166.32a1.62,1.62,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.67,1.67,0,0,1-1.68-1.68v-3.85a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.45,166.32a1.62,1.62,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.65,1.65,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.73,166.32a1.62,1.62,0,0,1-.49,1.19,1.69,1.69,0,0,1-2.38,0,1.62,1.62,0,0,1-.49-1.19v-3.85a1.67,1.67,0,0,1,1.68-1.68,1.63,1.63,0,0,1,1.2.49,1.65,1.65,0,0,1,.48,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,166.32a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.2-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.65,1.65,0,0,1,.49-1.19,1.7,1.7,0,0,1,2.39,0,1.66,1.66,0,0,1,.49,1.19Zm-1.11-3.87a.61.61,0,0,0-1-.43.57.57,0,0,0-.17.43v3.85a.57.57,0,0,0,.17.43.61.61,0,0,0,1-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.37,174.69v-5.42h-.91v-.75a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,173.08a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.65,1.65,0,0,1-.49-1.19v-3.84a1.69,1.69,0,0,1,1.69-1.69,1.62,1.62,0,0,1,1.19.5,1.65,1.65,0,0,1,.49,1.19Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.63.63,0,0,0-.17.43v3.85a.64.64,0,0,0,.17.44.58.58,0,0,0,.43.18.61.61,0,0,0,.62-.62Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.49,174.69v-5.42h-.9v-.75a1.49,1.49,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.85,173.08a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19v-3.84A1.63,1.63,0,0,1,342,168a1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.62,174.69v-5.42h-.91v-.75a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.2,192.7a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.59,1.59,0,0,1-1.19-.49,1.62,1.62,0,0,1-.5-1.19v-3.84a1.64,1.64,0,0,1,.5-1.2,1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.58.58,0,0,0-.43-.18.57.57,0,0,0-.43.18.6.6,0,0,0-.18.44v3.85a.6.6,0,0,0,.18.43.57.57,0,0,0,.43.18.58.58,0,0,0,.43-.18.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.26,173.08a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.65,1.65,0,0,1-.49-1.19v-3.84a1.69,1.69,0,0,1,1.69-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.63.63,0,0,0-.17.43v3.85a.64.64,0,0,0,.17.44.6.6,0,0,0,.43.18.61.61,0,0,0,.62-.62Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.54,173.08a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.59,1.59,0,0,1-1.19-.49,1.62,1.62,0,0,1-.5-1.19v-3.84a1.64,1.64,0,0,1,.5-1.2,1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.61.61,0,0,0-.61-.61.57.57,0,0,0-.43.18.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.52,144.11a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.65,1.65,0,0,1-.49-1.19v-3.84a1.69,1.69,0,0,1,1.69-1.69,1.62,1.62,0,0,1,1.19.5,1.65,1.65,0,0,1,.49,1.19Zm-1.1-3.86a.61.61,0,0,0-.62-.62.6.6,0,0,0-.43.18.64.64,0,0,0-.17.44v3.84a.64.64,0,0,0,.17.44.6.6,0,0,0,.43.18.61.61,0,0,0,.62-.62Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.93,143.48a1.67,1.67,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.68-1.68v-3.84a1.63,1.63,0,0,1,.49-1.2,1.66,1.66,0,0,1,1.19-.49,1.67,1.67,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.65,100.45a1.62,1.62,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.62,1.62,0,0,1-1.19-.5,1.59,1.59,0,0,1-.49-1.18V96.6a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.5,143.48a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.66,1.66,0,0,1-.49-1.19v-3.84a1.69,1.69,0,0,1,1.69-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.63.63,0,0,0-.17.43v3.85a.64.64,0,0,0,.17.44.6.6,0,0,0,.43.18.61.61,0,0,0,.62-.62Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.26,145.09v-5.42h-.9v-.75a1.56,1.56,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.1,145.09v-5.42h-.9v-.75a1.49,1.49,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.94,145.09v-5.42H264v-.75a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59H266v7.05Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.83,119.45V114h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.11,152.45a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.59,1.59,0,0,1-1.19-.49,1.62,1.62,0,0,1-.5-1.19v-3.84a1.6,1.6,0,0,1,.5-1.19,1.63,1.63,0,0,1,1.19-.5,1.6,1.6,0,0,1,1.19.5,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.63.63,0,0,0-.43-.17.6.6,0,0,0-.43.17.6.6,0,0,0-.18.44v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.73,136.35a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.67,1.67,0,0,1-1.68-1.68v-3.84a1.59,1.59,0,0,1,.49-1.19,1.63,1.63,0,0,1,1.19-.5,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.6.6,0,0,0,.18.43.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.67,152.45a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.63,1.63,0,0,1,1.19-.5,1.6,1.6,0,0,1,1.19.5,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.63.63,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.4,86.36V80.94h-.91v-.75a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,125.07a1.68,1.68,0,0,1-2.88,1.18,1.59,1.59,0,0,1-.49-1.18v-3.85a1.67,1.67,0,0,1,1.68-1.68,1.63,1.63,0,0,1,1.2.49,1.66,1.66,0,0,1,.49,1.19Zm-1.11-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56,154.06v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.92,152.45a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.63,1.63,0,0,1,1.19-.5,1.6,1.6,0,0,1,1.19.5,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.63.63,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69,154.06v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.05,152.45a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.61,1.61,0,0,1-.49-1.19v-3.84a1.71,1.71,0,0,1,1.69-1.69,1.63,1.63,0,0,1,1.19.5,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.64.64,0,0,0-.44-.17.61.61,0,0,0-.43.17.6.6,0,0,0-.17.44v3.85a.57.57,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.12,139.32V133.9h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.43,1.43,0,0,0,.5-.6h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.17,152.45a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.67,1.67,0,0,1-1.68-1.68v-3.84a1.59,1.59,0,0,1,.49-1.19,1.63,1.63,0,0,1,1.19-.5,1.6,1.6,0,0,1,1.19.5,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.63.63,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.94,154.06v-5.42H145v-.74a1.58,1.58,0,0,0,.73-.29,1.51,1.51,0,0,0,.5-.6H147v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.3,152.45a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.61,1.61,0,0,1-.49-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.68,1.68,0,0,1,2.39,0,1.66,1.66,0,0,1,.49,1.19Zm-1.11-3.86a.6.6,0,0,0-.18-.44.63.63,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.16,113.35v-5.42h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.75v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.42,152.45a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.59,1.59,0,0,1-1.19-.49,1.62,1.62,0,0,1-.5-1.19v-3.84a1.6,1.6,0,0,1,.5-1.19,1.63,1.63,0,0,1,1.19-.5,1.6,1.6,0,0,1,1.19.5,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.63.63,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.18,154.06v-5.42h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.51,1.51,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.55,152.45a1.69,1.69,0,0,1-1.69,1.68,1.67,1.67,0,0,1-1.68-1.68v-3.84a1.59,1.59,0,0,1,.49-1.19,1.68,1.68,0,0,1,2.39,0,1.66,1.66,0,0,1,.49,1.19Zm-1.11-3.86a.6.6,0,0,0-.18-.44.63.63,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.59,139.32V133.9h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.43,1.43,0,0,0,.5-.6h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.67,152.45a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.59,1.59,0,0,1-1.19-.49,1.62,1.62,0,0,1-.5-1.19v-3.84a1.6,1.6,0,0,1,.5-1.19,1.63,1.63,0,0,1,1.19-.5,1.6,1.6,0,0,1,1.19.5,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44A.63.63,0,0,0,171,148a.6.6,0,0,0-.43.17.6.6,0,0,0-.18.44v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.93,98.87V93.45H168v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59H170v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.8,75.63V70.21h-.9v-.75a1.5,1.5,0,0,0,.73-.28,1.47,1.47,0,0,0,.49-.6h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.25,123.23a1.62,1.62,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.62,1.62,0,0,1-1.19-.5,1.59,1.59,0,0,1-.49-1.18v-3.85a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.08,152.45a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.61,1.61,0,0,1-.49-1.19v-3.84a1.68,1.68,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19ZM183,148.59a.6.6,0,0,0-.18-.44.63.63,0,0,0-.86,0,.6.6,0,0,0-.17.44v3.85a.57.57,0,0,0,.17.43.61.61,0,0,0,1-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.36,152.45a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.65,1.65,0,0,1-.49-1.19v-3.84a1.68,1.68,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.64.64,0,0,0-.44-.17.63.63,0,0,0-.43.17.64.64,0,0,0-.17.44v3.85a.61.61,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.64,152.45a1.67,1.67,0,0,1-1.68,1.68,1.59,1.59,0,0,1-1.19-.49,1.62,1.62,0,0,1-.5-1.19v-3.84a1.68,1.68,0,0,1,2.88-1.19,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.63.63,0,0,0-.43-.17.6.6,0,0,0-.43.17.6.6,0,0,0-.18.44v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,108.23a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.67,1.67,0,0,1-1.68-1.68v-3.84a1.63,1.63,0,0,1,.49-1.2,1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.2,152.45a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.63,1.63,0,0,1,1.19-.5,1.6,1.6,0,0,1,1.19.5,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.63.63,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.54,121.46a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.67,1.67,0,0,1-1.68-1.68v-3.84a1.63,1.63,0,0,1,.49-1.2,1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.25,154.06v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.09,154.06v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.92,154.06v-5.42H212v-.74a1.63,1.63,0,0,0,.73-.29,1.41,1.41,0,0,0,.49-.6H214v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,124.83V119.4h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.48,1.48,0,0,0,.5-.59H216v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.6,154.06v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.44,154.06v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.51,1.51,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.92,132.75a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.69-1.68V128.9a1.63,1.63,0,0,1,.5-1.19,1.69,1.69,0,0,1,2.38,0,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.08,152.45a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.65,1.65,0,0,1-.49-1.19v-3.84a1.68,1.68,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.86a.6.6,0,0,0-.18-.44.64.64,0,0,0-.44-.17.63.63,0,0,0-.43.17.64.64,0,0,0-.17.44v3.85a.61.61,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.84,154.06v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.36,1.36,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.77,310.16v-5.43h-.91V304a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.61,310.16v-5.43H71.7V304a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.25,308.55a1.69,1.69,0,0,1-2.88,1.19,1.66,1.66,0,0,1-.49-1.19v-3.84a1.64,1.64,0,0,1,.5-1.2,1.61,1.61,0,0,1,1.19-.49,1.65,1.65,0,0,1,1.19.49,1.63,1.63,0,0,1,.49,1.2Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.64.64,0,0,0,.17.44.6.6,0,0,0,.43.18.61.61,0,0,0,.62-.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,310.16v-5.43h-.9V304a1.52,1.52,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.71,117.86a1.62,1.62,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.71,1.71,0,0,1-1.69-1.68V114a1.69,1.69,0,0,1,1.69-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.89,158.39V153H76v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59H78v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.46,147.72a1.62,1.62,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.69,1.69,0,0,1-1.69-1.68v-3.85a1.69,1.69,0,0,1,1.69-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.43-.18.57.57,0,0,0-.43.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.29,194a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.59,1.59,0,0,1-1.19-.49,1.62,1.62,0,0,1-.5-1.19V190.2a1.6,1.6,0,0,1,.5-1.19,1.63,1.63,0,0,1,1.19-.5,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.58.58,0,0,0-.43-.18.57.57,0,0,0-.43.18.6.6,0,0,0-.18.44V194a.6.6,0,0,0,.18.43.57.57,0,0,0,.43.18.58.58,0,0,0,.43-.18.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.57,194a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19V190.2a1.59,1.59,0,0,1,.49-1.19,1.63,1.63,0,0,1,1.19-.5,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44V194a.6.6,0,0,0,.18.43.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.34,195.65v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.7,194a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.61,1.61,0,0,1-.49-1.19V190.2a1.71,1.71,0,0,1,1.69-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.61.61,0,0,0-.62-.62.58.58,0,0,0-.43.18.6.6,0,0,0-.17.44V194a.59.59,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.46,195.65v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.82,194a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19V190.2A1.59,1.59,0,0,1,130,189a1.63,1.63,0,0,1,1.19-.5,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44V194a.6.6,0,0,0,.18.43.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.59,195.65v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.51,1.51,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,194a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.61,1.61,0,0,1-.49-1.19V190.2a1.68,1.68,0,0,1,2.88-1.19,1.65,1.65,0,0,1,.49,1.19Zm-1.11-3.86a.6.6,0,0,0-.18-.44.57.57,0,0,0-.43-.18.58.58,0,0,0-.43.18.6.6,0,0,0-.17.44V194a.59.59,0,0,0,.17.43.58.58,0,0,0,.43.18.57.57,0,0,0,.43-.18.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.3,175.63v-5.42h-.9v-.75a1.49,1.49,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.66,174a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49A1.67,1.67,0,0,1,270.3,174v-3.84a1.63,1.63,0,0,1,.49-1.2,1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44V174a.6.6,0,0,0,.18.44.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.43,175.63v-5.42h-.91v-.75a1.61,1.61,0,0,0,1.23-.88h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.79,174a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.61,1.61,0,0,1-.49-1.19v-3.84a1.63,1.63,0,0,1,.49-1.2,1.67,1.67,0,0,1,1.2-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.11-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44V174a.6.6,0,0,0,.18.44.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.6,175.07a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19v-3.84a1.63,1.63,0,0,1,.49-1.2,1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.6.6,0,0,0,.18.43.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.42,125.78a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.61,1.61,0,0,1-.49-1.19v-3.84a1.69,1.69,0,1,1,3.37,0Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.59.59,0,0,0-.17.43v3.85a.6.6,0,0,0,.17.44.58.58,0,0,0,.43.18.61.61,0,0,0,.62-.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.52,195.65v-5.42h-.9v-.74a1.67,1.67,0,0,0,.73-.29,1.41,1.41,0,0,0,.49-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.36,195.65v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.2,195.65v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,195.65v-5.42h-.9v-.74a1.58,1.58,0,0,0,.73-.29,1.51,1.51,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.87,195.65v-5.42H175v-.74a1.63,1.63,0,0,0,.73-.29,1.41,1.41,0,0,0,.49-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.23,194a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19V190.2a1.59,1.59,0,0,1,.49-1.19,1.63,1.63,0,0,1,1.19-.5,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44V194a.6.6,0,0,0,.18.43.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,195.65v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.36,194a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49A1.65,1.65,0,0,1,185,194V190.2a1.68,1.68,0,0,1,2.88-1.19,1.65,1.65,0,0,1,.49,1.19Zm-1.1-3.86a.61.61,0,0,0-.62-.62.58.58,0,0,0-.43.18.64.64,0,0,0-.17.44V194a.63.63,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.12,195.65v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,91.2a1.67,1.67,0,0,1-1.68,1.68,1.65,1.65,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19V87.35a1.67,1.67,0,0,1,1.68-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.25,195.65v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.61,194a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.61,1.61,0,0,1-.49-1.19V190.2a1.71,1.71,0,0,1,1.69-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.61.61,0,0,0-.62-.62.58.58,0,0,0-.43.18.6.6,0,0,0-.17.44V194a.59.59,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.89,194a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.65,1.65,0,0,1-.49-1.19V190.2A1.68,1.68,0,0,1,206.4,189a1.65,1.65,0,0,1,.49,1.19Zm-1.1-3.86a.61.61,0,0,0-.62-.62.6.6,0,0,0-.43.18.64.64,0,0,0-.17.44V194a.63.63,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.17,194a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.59,1.59,0,0,1-1.19-.49,1.62,1.62,0,0,1-.5-1.19V190.2a1.6,1.6,0,0,1,.5-1.19,1.63,1.63,0,0,1,1.19-.5,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.43-.18.57.57,0,0,0-.43.18.6.6,0,0,0-.18.44V194a.6.6,0,0,0,.18.43.57.57,0,0,0,.43.18.61.61,0,0,0,.61-.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.45,194a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.67,1.67,0,0,1-1.68-1.68V190.2a1.59,1.59,0,0,1,.49-1.19,1.63,1.63,0,0,1,1.19-.5,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44V194a.6.6,0,0,0,.18.43.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.22,195.65v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.43,1.43,0,0,0,.5-.6h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.05,195.65v-5.42h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.41,1.41,0,0,0,.49-.6h.75v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.89,195.65v-5.42H222v-.74a1.59,1.59,0,0,0,.72-.29,1.43,1.43,0,0,0,.5-.6H224v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.75,152.46a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19v-3.84a1.63,1.63,0,0,1,.49-1.2,1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.84a.6.6,0,0,0,.18.44.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08,187.91v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.44,1.44,0,0,0,.5-.6h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.44,186.3a1.69,1.69,0,0,1-2.88,1.19,1.61,1.61,0,0,1-.49-1.19v-3.84a1.68,1.68,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.11-3.86a.58.58,0,0,0-.18-.43.57.57,0,0,0-.43-.18.58.58,0,0,0-.43.18.57.57,0,0,0-.17.43v3.85a.57.57,0,0,0,.17.43.58.58,0,0,0,.43.18.57.57,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.2,187.91v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.37,1.37,0,0,0,.5-.6h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.64,237.39V232h-.91v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.34,232.83a1.69,1.69,0,1,1-3.37,0V229a1.69,1.69,0,0,1,2.88-1.2,1.67,1.67,0,0,1,.49,1.2ZM79.23,229A.61.61,0,0,0,78,229v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.78,209.51v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.14,207.9a1.67,1.67,0,0,1-1.68,1.69,1.71,1.71,0,0,1-1.69-1.69v-3.84a1.69,1.69,0,0,1,2.88-1.19,1.62,1.62,0,0,1,.49,1.19ZM116,204a.58.58,0,0,0-.18-.43.6.6,0,0,0-.43-.18.57.57,0,0,0-.43.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.42,207.9a1.63,1.63,0,0,1-.49,1.2,1.66,1.66,0,0,1-1.19.49,1.69,1.69,0,0,1-1.68-1.69v-3.84a1.59,1.59,0,0,1,.49-1.19,1.62,1.62,0,0,1,1.19-.49,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.7,207.9a1.63,1.63,0,0,1-.49,1.2,1.66,1.66,0,0,1-1.19.49,1.62,1.62,0,0,1-1.19-.5,1.59,1.59,0,0,1-.49-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.62,1.62,0,0,1,1.19-.49,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19ZM124.6,204a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.47,209.51v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.83,207.9a1.69,1.69,0,1,1-3.37,0v-3.84a1.69,1.69,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.86a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.59,209.51v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,227.9a1.63,1.63,0,0,1-.49,1.2,1.66,1.66,0,0,1-1.19.49,1.62,1.62,0,0,1-1.19-.5,1.59,1.59,0,0,1-.49-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.62,1.62,0,0,1,1.19-.49,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.72,229.51v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.08,227.9a1.68,1.68,0,0,1-2.88,1.19,1.59,1.59,0,0,1-.49-1.19v-3.84a1.69,1.69,0,0,1,1.69-1.68,1.62,1.62,0,0,1,1.19.49,1.66,1.66,0,0,1,.49,1.19ZM146,224a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.57.57,0,0,0-.17.43v3.85a.57.57,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.84,229.51v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.2,227.9a1.63,1.63,0,0,1-.49,1.2,1.66,1.66,0,0,1-1.19.49,1.69,1.69,0,0,1-1.68-1.69v-3.84a1.59,1.59,0,0,1,.49-1.19,1.62,1.62,0,0,1,1.19-.49,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19ZM153.1,224a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.47,250.8A1.61,1.61,0,0,1,129,252a1.66,1.66,0,0,1-1.19.49,1.65,1.65,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19V247a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.76,227.9a1.63,1.63,0,0,1-.49,1.2,1.68,1.68,0,0,1-2.38,0,1.59,1.59,0,0,1-.49-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.7,1.7,0,0,1,2.39,0,1.65,1.65,0,0,1,.48,1.19Zm-1.1-3.86a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.05,227.9a1.68,1.68,0,0,1-2.88,1.19,1.59,1.59,0,0,1-.49-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.7,1.7,0,0,1,2.39,0,1.66,1.66,0,0,1,.49,1.19ZM165.94,224a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.33,227.9a1.69,1.69,0,1,1-3.37,0v-3.84a1.69,1.69,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.86a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.61,227.9a1.69,1.69,0,0,1-1.68,1.69,1.71,1.71,0,0,1-1.69-1.69v-3.84a1.69,1.69,0,0,1,2.88-1.19,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.58.58,0,0,0-.18-.43.6.6,0,0,0-.43-.18.57.57,0,0,0-.43.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.89,227.9a1.63,1.63,0,0,1-.49,1.2,1.66,1.66,0,0,1-1.19.49,1.69,1.69,0,0,1-1.68-1.69v-3.84a1.59,1.59,0,0,1,.49-1.19,1.62,1.62,0,0,1,1.19-.49,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.65,209.51v-5.42h-.9v-.74a1.58,1.58,0,0,0,.73-.29,1.48,1.48,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.49,209.51v-5.42h-.9v-.74a1.67,1.67,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.33,209.51v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.17,209.51v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,209.51v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.48,1.48,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.84,209.51v-5.42h-.9v-.74a1.67,1.67,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.2,207.9a1.63,1.63,0,0,1-.49,1.2,1.66,1.66,0,0,1-1.19.49,1.62,1.62,0,0,1-1.19-.5,1.59,1.59,0,0,1-.49-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.62,1.62,0,0,1,1.19-.49,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19ZM200.1,204a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.48,207.9a1.63,1.63,0,0,1-.49,1.2,1.66,1.66,0,0,1-1.19.49,1.63,1.63,0,0,1-1.19-.5,1.59,1.59,0,0,1-.49-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.7,1.7,0,0,1,2.39,0,1.65,1.65,0,0,1,.48,1.19Zm-1.1-3.86a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.25,209.51v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.61,207.9a1.69,1.69,0,1,1-3.37,0v-3.84a1.69,1.69,0,0,1,2.88-1.19,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.56.56,0,0,0-.42.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.56.56,0,0,0,.42.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.37,209.51v-5.42h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.75v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.21,209.51v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.05,209.51v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.89,209.51v-5.42H222v-.74a1.58,1.58,0,0,0,.73-.29,1.48,1.48,0,0,0,.5-.59H224v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,207.9a1.68,1.68,0,0,1-2.88,1.19,1.59,1.59,0,0,1-.49-1.19v-3.84a1.69,1.69,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19ZM227.14,204a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,209.51v-5.42h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.37,207.9a1.63,1.63,0,0,1-.49,1.2,1.66,1.66,0,0,1-1.19.49A1.71,1.71,0,0,1,232,207.9v-3.84a1.6,1.6,0,0,1,.5-1.19,1.62,1.62,0,0,1,1.19-.49,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.61.61,0,0,0-.61-.61.57.57,0,0,0-.43.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.61.61,0,0,0,.61-.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.13,209.51v-5.42h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.75v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.42,180.18a1.69,1.69,0,1,1-3.37,0v-3.84a1.67,1.67,0,0,1,.49-1.2,1.69,1.69,0,0,1,2.88,1.2Zm-1.11-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,87.89V82.47h-.91v-.75a1.61,1.61,0,0,0,1.23-.88h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.54,180.18a1.68,1.68,0,0,1-2.87,1.19,1.63,1.63,0,0,1-.5-1.19v-3.84a1.69,1.69,0,0,1,1.69-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.58.58,0,0,0-.43-.18.57.57,0,0,0-.43.18.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.56.56,0,0,0,.43.17.57.57,0,0,0,.43-.17.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.3,181.79v-5.43h-.9v-.74a1.52,1.52,0,0,0,.73-.29,1.48,1.48,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.08,209.6a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19v-3.84a1.63,1.63,0,0,1,.49-1.2,1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69ZM71,205.74a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.85a.6.6,0,0,0,.18.43.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.43,181.79v-5.43h-.91v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.79,180.18a1.68,1.68,0,0,1-2.87,1.19,1.63,1.63,0,0,1-.5-1.19v-3.84a1.69,1.69,0,0,1,1.69-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.61.61,0,0,0-.61-.61.57.57,0,0,0-.43.18.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.56.56,0,0,0,.43.17.59.59,0,0,0,.43-.17.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.07,180.18a1.68,1.68,0,1,1-3.36,0v-3.84a1.67,1.67,0,0,1,1.68-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.35,180.18a1.68,1.68,0,1,1-3.36,0v-3.84a1.67,1.67,0,0,1,1.68-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.12,181.79v-5.43h-.91v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.48,180.18a1.69,1.69,0,0,1-2.88,1.19,1.66,1.66,0,0,1-.49-1.19v-3.84a1.64,1.64,0,0,1,.5-1.2,1.68,1.68,0,0,1,2.38,0,1.63,1.63,0,0,1,.49,1.19Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.63.63,0,0,0-.17.43v3.85a.64.64,0,0,0,.17.44.57.57,0,0,0,.43.17.6.6,0,0,0,.44-.17.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,181.79v-5.43h-.9v-.74a1.49,1.49,0,0,0,.72-.29,1.34,1.34,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.6,180.18a1.68,1.68,0,1,1-3.36,0v-3.84a1.67,1.67,0,0,1,1.68-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.53,186.89a1.62,1.62,0,0,1-.5,1.19,1.68,1.68,0,0,1-2.38,0,1.62,1.62,0,0,1-.49-1.18V183A1.69,1.69,0,0,1,54,181.85a1.66,1.66,0,0,1,.49,1.19ZM53.43,183a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.81,186.89a1.65,1.65,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.71,1.71,0,0,1-1.69-1.68V183a1.69,1.69,0,1,1,3.37,0ZM57.71,183a.58.58,0,0,0-.18-.43.6.6,0,0,0-.43-.18.57.57,0,0,0-.43.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.57,188.49v-5.42h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.75v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.93,186.89a1.61,1.61,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.63,1.63,0,0,1-1.19-.5,1.59,1.59,0,0,1-.49-1.18V183a1.67,1.67,0,0,1,1.68-1.68,1.63,1.63,0,0,1,1.2.49,1.65,1.65,0,0,1,.48,1.19ZM64.83,183a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7,188.49v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.06,186.89a1.62,1.62,0,0,1-.5,1.19,1.68,1.68,0,0,1-2.38,0,1.62,1.62,0,0,1-.49-1.18V183a1.69,1.69,0,1,1,3.37,0ZM72,183a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.56.56,0,0,0-.42.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.56.56,0,0,0,.42.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.37,181.79v-5.43h-.91v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.73,180.18a1.69,1.69,0,0,1-2.88,1.19,1.66,1.66,0,0,1-.49-1.19v-3.84a1.64,1.64,0,0,1,.5-1.2,1.61,1.61,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.63.63,0,0,0-.17.43v3.85a.64.64,0,0,0,.17.44.57.57,0,0,0,.43.17.6.6,0,0,0,.44-.17.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.49,181.79v-5.43h-.9v-.74a1.49,1.49,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.85,180.18a1.68,1.68,0,1,1-3.36,0v-3.84a1.67,1.67,0,0,1,1.68-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.13,180.18a1.68,1.68,0,1,1-3.36,0v-3.84a1.67,1.67,0,0,1,1.68-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.41,180.18a1.68,1.68,0,1,1-3.36,0v-3.84a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.7,180.18a1.69,1.69,0,1,1-3.37,0v-3.84a1.67,1.67,0,0,1,.49-1.2,1.69,1.69,0,0,1,2.88,1.2Zm-1.11-3.87a.6.6,0,0,0-.18-.43.57.57,0,0,0-.43-.18.58.58,0,0,0-.43.18.59.59,0,0,0-.17.43v3.85a.6.6,0,0,0,.17.44.57.57,0,0,0,.43.17.56.56,0,0,0,.43-.17.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.21,245.83a1.67,1.67,0,0,1-1.68,1.68,1.66,1.66,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19V242a1.69,1.69,0,0,1,2.88-1.2,1.66,1.66,0,0,1,.48,1.2Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.26,180.18a1.65,1.65,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.59,1.59,0,0,1-1.19-.49,1.63,1.63,0,0,1-.5-1.19v-3.84a1.64,1.64,0,0,1,.5-1.2,1.69,1.69,0,0,1,2.87,1.2Zm-1.1-3.87a.61.61,0,0,0-.61-.61.57.57,0,0,0-.43.18.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.56.56,0,0,0,.43.17.59.59,0,0,0,.43-.17.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.54,180.18a1.68,1.68,0,1,1-3.36,0v-3.84a1.67,1.67,0,0,1,1.68-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.31,181.79v-5.43h-.91v-.74a1.61,1.61,0,0,0,1.23-.88h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.14,181.79v-5.43h-.9v-.74a1.52,1.52,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,181.79v-5.43h-.9v-.74a1.49,1.49,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59H199v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.82,181.79v-5.43h-.91v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.49,141.56v-5.43h-.91v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.49,181.79v-5.43h-.9v-.74a1.56,1.56,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.85,180.18a1.68,1.68,0,1,1-3.36,0v-3.84a1.67,1.67,0,0,1,1.68-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.13,180.18a1.68,1.68,0,1,1-3.36,0v-3.84a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.9,181.79v-5.43H217v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59H219v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.26,180.18a1.69,1.69,0,0,1-1.68,1.68,1.59,1.59,0,0,1-1.19-.49,1.63,1.63,0,0,1-.5-1.19v-3.84a1.64,1.64,0,0,1,.5-1.2,1.69,1.69,0,0,1,2.87,1.2Zm-1.1-3.87a.61.61,0,0,0-.61-.61.57.57,0,0,0-.43.18.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.56.56,0,0,0,.43.17.59.59,0,0,0,.43-.17.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,181.79v-5.43h-.9v-.74a1.52,1.52,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.75v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.46,160.1v-5.43h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.7,181.79v-5.43h-.91v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.54,181.79v-5.43h-.91v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.9,180.18a1.69,1.69,0,1,1-3.37,0v-3.84a1.67,1.67,0,0,1,.49-1.2,1.69,1.69,0,0,1,2.88,1.2Zm-1.11-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.45,284.77a1.67,1.67,0,0,1-1.68,1.68,1.65,1.65,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19v-3.84a1.67,1.67,0,0,1,1.68-1.69,1.59,1.59,0,0,1,1.19.49,1.63,1.63,0,0,1,.49,1.2Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.22,286.38V281h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.58,284.77a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.69-1.68v-3.84a1.64,1.64,0,0,1,.5-1.2,1.69,1.69,0,0,1,2.38,0,1.67,1.67,0,0,1,.49,1.2Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.57.57,0,0,0-.17.43v3.85a.57.57,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.34,286.38V281h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.66,221.77a1.67,1.67,0,0,1-1.68,1.68,1.66,1.66,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.69,1.69,0,0,1,2.88-1.19,1.65,1.65,0,0,1,.48,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.43,223.38V218h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,253.32a1.62,1.62,0,0,1-.5,1.19,1.68,1.68,0,0,1-2.38,0,1.59,1.59,0,0,1-.49-1.18v-3.85a1.61,1.61,0,0,1,.49-1.19,1.7,1.7,0,0,1,2.39,0,1.66,1.66,0,0,1,.49,1.19Zm-1.11-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.07,221.77a1.67,1.67,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.68-1.68v-3.85a1.67,1.67,0,0,1,1.68-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19ZM131,217.9a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.35,221.77a1.67,1.67,0,0,1-1.68,1.68,1.65,1.65,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.67,1.67,0,0,1,1.68-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.12,243.38V238h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.48,241.77a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.69-1.68v-3.85a1.63,1.63,0,0,1,.5-1.19,1.69,1.69,0,0,1,2.38,0,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,243.38V238h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.34,1.34,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.6,241.77a1.67,1.67,0,0,1-1.68,1.68,1.65,1.65,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.67,1.67,0,0,1,1.68-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.37,243.38V238h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.73,241.77a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.69-1.68v-3.85a1.63,1.63,0,0,1,.5-1.19,1.69,1.69,0,0,1,2.38,0,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.49,243.38V238h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.85,241.77a1.67,1.67,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.68-1.68v-3.85a1.67,1.67,0,0,1,1.68-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.16,272.89a1.69,1.69,0,1,1-3.37,0v-3.84a1.69,1.69,0,0,1,2.88-1.19,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.44,272.89a1.66,1.66,0,0,1-1.68,1.68,1.69,1.69,0,0,1-1.69-1.68v-3.84a1.69,1.69,0,0,1,2.88-1.19,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.58.58,0,0,0-.18-.43.6.6,0,0,0-.43-.18.57.57,0,0,0-.43.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.72,272.89a1.63,1.63,0,0,1-.49,1.2,1.65,1.65,0,0,1-1.19.48,1.67,1.67,0,0,1-1.68-1.68v-3.84a1.59,1.59,0,0,1,.49-1.19,1.62,1.62,0,0,1,1.19-.49,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.86a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.28,317.53a1.62,1.62,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.63,1.63,0,0,1-1.19-.5,1.59,1.59,0,0,1-.49-1.18v-3.85A1.67,1.67,0,0,1,164.6,312a1.63,1.63,0,0,1,1.2.49,1.65,1.65,0,0,1,.48,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.28,272.89a1.68,1.68,0,0,1-2.87,1.19,1.59,1.59,0,0,1-.49-1.19v-3.84a1.59,1.59,0,0,1,.49-1.19,1.7,1.7,0,0,1,2.39,0,1.65,1.65,0,0,1,.48,1.19Zm-1.1-3.86a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.57,272.89a1.69,1.69,0,0,1-2.88,1.19,1.59,1.59,0,0,1-.49-1.19v-3.84a1.69,1.69,0,0,1,1.69-1.68,1.62,1.62,0,0,1,1.19.49,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.86a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.57.57,0,0,0-.17.43v3.85a.57.57,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.31,223.38V218h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.48,1.48,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.14,223.38V218h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,223.38V218h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59H199v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.82,223.38V218h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.65,223.38V218h-.9v-.74a1.58,1.58,0,0,0,.73-.29,1.48,1.48,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.87,252.4V247H184v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.85,221.77a1.67,1.67,0,0,1-1.68,1.68A1.65,1.65,0,0,1,209,223a1.62,1.62,0,0,1-.49-1.19v-3.85a1.67,1.67,0,0,1,1.68-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.13,221.77a1.67,1.67,0,0,1-1.68,1.68,1.66,1.66,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.69,1.69,0,0,1,2.88-1.19,1.65,1.65,0,0,1,.48,1.19ZM215,217.9a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.9,223.38V218H217v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59H219v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.26,221.77a1.69,1.69,0,0,1-3.37,0v-3.85a1.63,1.63,0,0,1,.5-1.19,1.68,1.68,0,0,1,2.87,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.43-.18.57.57,0,0,0-.43.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,223.38V218h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.75v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.86,223.38V218H227v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11,292.48v-5.43h-.91v-.74a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.94,292.48v-5.43H252v-.74a1.52,1.52,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59H254v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.3,290.87a1.68,1.68,0,1,1-3.36,0V287a1.69,1.69,0,0,1,2.88-1.2,1.66,1.66,0,0,1,.48,1.2ZM257.2,287a.61.61,0,0,0-1.22,0v3.85a.6.6,0,0,0,.18.44.63.63,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.72,297.16a1.61,1.61,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.69,1.69,0,0,1-1.69-1.68v-3.85a1.69,1.69,0,0,1,1.69-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.43-.18.57.57,0,0,0-.43.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.88,167.92V162.5H108v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.24,166.32a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.69-1.68v-3.85a1.69,1.69,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.87A.58.58,0,0,0,113,162a.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,167.92V162.5h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7,177.63a1.62,1.62,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.69,1.69,0,0,1-1.68-1.68v-3.85a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.13,167.92V162.5h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.49,166.32a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.2-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.69,1.69,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.57.57,0,0,0-.17.43v3.85a.57.57,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.77,166.32a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.69-1.68v-3.85a1.69,1.69,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.11,93.75a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.59,1.59,0,0,1-1.19-.49,1.62,1.62,0,0,1-.5-1.19V89.91a1.64,1.64,0,0,1,.5-1.2,1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69ZM112,89.89a.6.6,0,0,0-.18-.44.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.44v3.84a.6.6,0,0,0,.18.44.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.88,95.36V89.94H114v-.75a1.47,1.47,0,0,0,.73-.28,1.51,1.51,0,0,0,.5-.6h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.17,166.32a1.62,1.62,0,0,1-.49,1.19,1.69,1.69,0,0,1-2.38,0,1.62,1.62,0,0,1-.49-1.19v-3.85a1.67,1.67,0,0,1,1.68-1.68,1.63,1.63,0,0,1,1.2.49,1.65,1.65,0,0,1,.48,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.94,167.92V162.5H145v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59H147v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.93,140a1.61,1.61,0,0,1-.49,1.19,1.65,1.65,0,0,1-1.19.49,1.66,1.66,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.69,1.69,0,0,1,2.88-1.19,1.65,1.65,0,0,1,.48,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.7,141.56v-5.42h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.06,140a1.61,1.61,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.69,1.69,0,0,1-1.69-1.68v-3.85a1.69,1.69,0,0,1,1.69-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.61.61,0,0,0-.61-.61.57.57,0,0,0-.43.18.58.58,0,0,0-.18.43v3.85a.58.58,0,0,0,.18.43.57.57,0,0,0,.43.18.61.61,0,0,0,.61-.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.82,141.56v-5.42h-.9v-.74a1.63,1.63,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.75v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.31,69.16a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.2-.49,1.62,1.62,0,0,1-.49-1.19V65.31a1.63,1.63,0,0,1,.5-1.19,1.59,1.59,0,0,1,1.19-.49,1.62,1.62,0,0,1,1.19.49,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.57.57,0,0,0-.17.43v3.85a.57.57,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.07,70.77V65.34h-.9V64.6a1.49,1.49,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.43,69.16a1.67,1.67,0,0,1-1.68,1.68,1.65,1.65,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19V65.31a1.67,1.67,0,0,1,1.68-1.68,1.59,1.59,0,0,1,1.19.49,1.62,1.62,0,0,1,.49,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.2,70.77V65.34h-.91V64.6a1.61,1.61,0,0,0,1.23-.88h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.55,166.32a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.69-1.68v-3.85a1.69,1.69,0,1,1,3.37,0Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.6.6,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.31,167.92V162.5h-.9v-.74a1.67,1.67,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.67,166.32a1.62,1.62,0,0,1-.49,1.19A1.66,1.66,0,0,1,171,168a1.65,1.65,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.44,167.92V162.5h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.8,166.32a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.69-1.68v-3.85a1.69,1.69,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.61.61,0,0,0-.17.43v3.85a.61.61,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.56,167.92V162.5h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.92,166.32a1.62,1.62,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.65,1.65,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.69,167.92V162.5h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.05,166.32a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.2-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.69,1.69,0,0,1,2.88-1.19,1.66,1.66,0,0,1,.49,1.19Zm-1.1-3.87a.58.58,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.57.57,0,0,0-.17.43v3.85a.57.57,0,0,0,.17.43.58.58,0,0,0,.43.18.6.6,0,0,0,.44-.18.58.58,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.81,167.92V162.5h-.9v-.74a1.59,1.59,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.17,166.32a1.62,1.62,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.67,1.67,0,0,1-1.68-1.68v-3.85a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.45,166.32a1.62,1.62,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.65,1.65,0,0,1-1.19-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.73,166.32a1.62,1.62,0,0,1-.49,1.19,1.69,1.69,0,0,1-2.38,0,1.62,1.62,0,0,1-.49-1.19v-3.85a1.67,1.67,0,0,1,1.68-1.68,1.63,1.63,0,0,1,1.2.49,1.65,1.65,0,0,1,.48,1.19Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,166.32a1.69,1.69,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.2-.49,1.62,1.62,0,0,1-.49-1.19v-3.85a1.65,1.65,0,0,1,.49-1.19,1.7,1.7,0,0,1,2.39,0,1.66,1.66,0,0,1,.49,1.19Zm-1.11-3.87a.61.61,0,0,0-1-.43.57.57,0,0,0-.17.43v3.85a.57.57,0,0,0,.17.43.61.61,0,0,0,1-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.37,174.69v-5.42h-.91v-.75a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,173.08a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.65,1.65,0,0,1-.49-1.19v-3.84a1.69,1.69,0,0,1,1.69-1.69,1.62,1.62,0,0,1,1.19.5,1.65,1.65,0,0,1,.49,1.19Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.44-.18.58.58,0,0,0-.43.18.63.63,0,0,0-.17.43v3.85a.64.64,0,0,0,.17.44.58.58,0,0,0,.43.18.61.61,0,0,0,.62-.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.49,174.69v-5.42h-.9v-.75a1.49,1.49,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.85,173.08a1.59,1.59,0,0,1-.49,1.19,1.68,1.68,0,0,1-2.87-1.19v-3.84A1.63,1.63,0,0,1,342,168a1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.62,174.69v-5.42h-.91v-.75a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.2,192.7a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.59,1.59,0,0,1-1.19-.49,1.62,1.62,0,0,1-.5-1.19v-3.84a1.64,1.64,0,0,1,.5-1.2,1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.86a.6.6,0,0,0-.18-.44.58.58,0,0,0-.43-.18.57.57,0,0,0-.43.18.6.6,0,0,0-.18.44v3.85a.6.6,0,0,0,.18.43.57.57,0,0,0,.43.18.58.58,0,0,0,.43-.18.6.6,0,0,0,.18-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.26,173.08a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.65,1.65,0,0,1-.49-1.19v-3.84a1.69,1.69,0,0,1,1.69-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.63.63,0,0,0-.17.43v3.85a.64.64,0,0,0,.17.44.6.6,0,0,0,.43.18.61.61,0,0,0,.62-.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.54,173.08a1.59,1.59,0,0,1-.49,1.19,1.62,1.62,0,0,1-1.19.49,1.59,1.59,0,0,1-1.19-.49,1.62,1.62,0,0,1-.5-1.19v-3.84a1.64,1.64,0,0,1,.5-1.2,1.66,1.66,0,0,1,1.19-.49,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.61.61,0,0,0-.61-.61.57.57,0,0,0-.43.18.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.57.57,0,0,0,.43.18.6.6,0,0,0,.43-.18.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.52,144.11a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.65,1.65,0,0,1-.49-1.19v-3.84a1.69,1.69,0,0,1,1.69-1.69,1.62,1.62,0,0,1,1.19.5,1.65,1.65,0,0,1,.49,1.19Zm-1.1-3.86a.61.61,0,0,0-.62-.62.6.6,0,0,0-.43.18.64.64,0,0,0-.17.44v3.84a.64.64,0,0,0,.17.44.6.6,0,0,0,.43.18.61.61,0,0,0,.62-.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.93,143.48a1.67,1.67,0,0,1-1.68,1.68,1.67,1.67,0,0,1-1.68-1.68v-3.84a1.63,1.63,0,0,1,.49-1.2,1.66,1.66,0,0,1,1.19-.49,1.67,1.67,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.86,0,.6.6,0,0,0-.18.43v3.85a.6.6,0,0,0,.18.44.6.6,0,0,0,.86,0,.6.6,0,0,0,.18-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.65,100.45a1.62,1.62,0,0,1-.49,1.19,1.66,1.66,0,0,1-1.19.49,1.62,1.62,0,0,1-1.19-.5,1.59,1.59,0,0,1-.49-1.18V96.6a1.68,1.68,0,1,1,3.36,0Zm-1.1-3.87a.61.61,0,0,0-1.22,0v3.85a.61.61,0,0,0,1.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.5,143.48a1.69,1.69,0,0,1-1.68,1.68,1.63,1.63,0,0,1-1.2-.49,1.66,1.66,0,0,1-.49-1.19v-3.84a1.69,1.69,0,0,1,1.69-1.69,1.69,1.69,0,0,1,1.68,1.69Zm-1.1-3.87a.6.6,0,0,0-.18-.43.6.6,0,0,0-.44-.18.6.6,0,0,0-.43.18.63.63,0,0,0-.17.43v3.85a.64.64,0,0,0,.17.44.6.6,0,0,0,.43.18.61.61,0,0,0,.62-.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.26,145.09v-5.42h-.9v-.75a1.56,1.56,0,0,0,.73-.29,1.38,1.38,0,0,0,.49-.59h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.1,145.09v-5.42h-.9v-.75a1.49,1.49,0,0,0,.72-.29,1.41,1.41,0,0,0,.5-.59h.74v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.94,145.09v-5.42H264v-.75a1.48,1.48,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59H266v7.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.83,119.45V114h-.91v-.74a1.58,1.58,0,0,0,.73-.29,1.41,1.41,0,0,0,.5-.59h.74v7Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--trash-bin--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.43,394.19a3,3,0,0,0-2.39-4.27,6.36,6.36,0,0,0-2-7,1.47,1.47,0,0,0-.87-.39,1.7,1.7,0,0,0-.94.41l-5.58,4a3.4,3.4,0,0,0-1.11,1.09c-1.14,2.21,3,5,1.28,6.86-.48.52-1.26.63-1.87,1-1.32.83-1.48,2.65-2.1,4.09s-2.78,2.55-3.6,1.22c.61-1.38-1.24-2.57-2.73-2.74s-3.06-.26-3.89-1.66c-2.12,1.85-6.88-3.33-6.77-5.41-1.75.13-2.94,1.76-3.32,3.4a25.05,25.05,0,0,0-.18,5.2c0,3.38-1.14,6.7-1.08,10.08,0,2.63,1.06,5.55,3.47,6.61a9.05,9.05,0,0,0,3.74.5l27.43-.18a4,4,0,0,0,1.92-.32c1.24-.64,1.5-2.27,1.62-3.66l1.47-17.88Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.43,394.19a3,3,0,0,0-2.39-4.27,6.36,6.36,0,0,0-2-7,1.47,1.47,0,0,0-.87-.39,1.7,1.7,0,0,0-.94.41l-5.58,4a3.4,3.4,0,0,0-1.11,1.09c-1.14,2.21,3,5,1.28,6.86-.48.52-1.26.63-1.87,1-1.32.83-1.48,2.65-2.1,4.09s-2.78,2.55-3.6,1.22c.61-1.38-1.24-2.57-2.73-2.74s-3.06-.26-3.89-1.66c-2.12,1.85-6.88-3.33-6.77-5.41-1.75.13-2.94,1.76-3.32,3.4a25.05,25.05,0,0,0-.18,5.2c0,3.38-1.14,6.7-1.08,10.08,0,2.63,1.06,5.55,3.47,6.61a9.05,9.05,0,0,0,3.74.5l27.43-.18a4,4,0,0,0,1.92-.32c1.24-.64,1.5-2.27,1.62-3.66l1.47-17.88Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,365.2H380.47l.35,4.3.25,3.07.65,8,.37,4.59.49,6.11.21,2.62.07.78.25,3.08.34,4.22.21,2.62.22,2.66.25,3.08.19,2.33.21,2.62.09,1.14h39.06l.09-1.14.21-2.61.19-2.35.25-3.08.22-2.65.21-2.62.34-4.23.25-3.07.06-.78.21-2.62.5-6.11.37-4.58.64-8,.25-3.07.35-4.3Zm2.56,2.82h0l-.82-.82h.89Zm-.21,2.61-.08,1-3.81,3.81-4.37-4.37L421,367.2H422Zm-1.1,13.62L421.49,387l-4.37-4.37,4.37-4.36,3,3Zm-40.5-2.92h0l3-3,4.37,4.36L386.8,387,384,384.25Zm36.3-4.44-4.37,4.37-4.37-4.37,4.37-4.37Zm-6.87-9.69h5l-2.5,2.5Zm1.08,15.47L409.93,387l-4.37-4.37,4.37-4.36Zm-14.51,5.78,4.37-4.36,4.36,4.36-4.36,4.37Zm3,5.78-4.37,4.37L394,394.24l4.37-4.37Zm7.2-4.36,4.36,4.37-4.36,4.36-4.37-4.37Zm-5.78-8.61-4.37-4.37,4.37-4.37,4.36,4.37Zm-1.42,1.41L398.37,387,394,382.67l4.37-4.36Zm-10.15-1.41-4.36-4.37,4.36-4.37,4.37,4.37Zm0,2.83,4.37,4.36-4.37,4.37-4.36-4.37ZM397,400l-4.37,4.36L388.22,400l4.36-4.37Zm1.41,1.41,4.37,4.37-4.36,4.37L394,405.8Zm1.42-1.41,4.37-4.37,4.36,4.37-4.36,4.36Zm10.15,1.41,4.36,4.37-4.36,4.37-4.37-4.37Zm5.78,5.78,4.37,4.37-2.83,2.83h-3.08l-2.83-2.83ZM411.34,400l4.37-4.37,4.37,4.37-4.37,4.36Zm0-11.57,4.37-4.36,4.37,4.36-4.37,4.37Zm3-17.34-4.36,4.37-4.37-4.37,3.91-3.91h.92Zm-10.14-1.41-2.5-2.5h5Zm-1.42,1.41-4.36,4.37L394,371.11l3.91-3.91h.92Zm-7.65-3.91-2.5,2.5-2.49-2.5Zm-7.82,0,3.91,3.91-4.37,4.37-3.8-3.81-.08-1,3.42-3.43Zm-3.74,0-.81.81h0l-.07-.81Zm-.27,7.55,2.14,2.14-1.82,1.82Zm1.19,14.65-.17-2.07h0l1.12,1.12-.95.95Zm.21,2.63,2.15-2.16,4.37,4.37-4.37,4.36L385,396.84Zm.65,8.08v-.19l.1.1-.09.09Zm.76,9.31-.55-6.7,1.29-1.29,4.37,4.37-4.37,4.36-.74-.74Zm.4,5-.08-1,.42-.42,1.42,1.42Zm1.76-2.83,4.36-4.37,4.37,4.37-2.83,2.83H391Zm8.73,2.83,1.42-1.42,1.42,1.42Zm5.66,0-2.83-2.83,4.37-4.37,4.36,4.37-2.82,2.83Zm5.9,0,1.42-1.42,1.42,1.42Zm13.32,0h-1.76l1.42-1.42.42.42Zm.41-5-.75.74-4.37-4.36,4.37-4.37,1.29,1.29Zm.77-9.51,0,.2-.09-.09.11-.11Zm.25-3.07-1.77,1.76-4.37-4.36,4.37-4.37,2.16,2.16Zm.6-7.43-1-1,1.13-1.12Zm1.19-14.67-.32,4-1.83-1.83,2.15-2.15Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423,365.2H380.47l.35,4.3.25,3.07.65,8,.37,4.59.49,6.11.21,2.62.07.78.25,3.08.34,4.22.21,2.62.22,2.66.25,3.08.19,2.33.21,2.62.09,1.14h39.06l.09-1.14.21-2.61.19-2.35.25-3.08.22-2.65.21-2.62.34-4.23.25-3.07.06-.78.21-2.62.5-6.11.37-4.58.64-8,.25-3.07.35-4.3Zm2.56,2.82h0l-.82-.82h.89Zm-.21,2.61-.08,1-3.81,3.81-4.37-4.37L421,367.2H422Zm-1.1,13.62L421.49,387l-4.37-4.37,4.37-4.36,3,3Zm-40.5-2.92h0l3-3,4.37,4.36L386.8,387,384,384.25Zm36.3-4.44-4.37,4.37-4.37-4.37,4.37-4.37Zm-6.87-9.69h5l-2.5,2.5Zm1.08,15.47L409.93,387l-4.37-4.37,4.37-4.36Zm-14.51,5.78,4.37-4.36,4.36,4.36-4.36,4.37Zm3,5.78-4.37,4.37L394,394.24l4.37-4.37Zm7.2-4.36,4.36,4.37-4.36,4.36-4.37-4.37Zm-5.78-8.61-4.37-4.37,4.37-4.37,4.36,4.37Zm-1.42,1.41L398.37,387,394,382.67l4.37-4.36Zm-10.15-1.41-4.36-4.37,4.36-4.37,4.37,4.37Zm0,2.83,4.37,4.36-4.37,4.37-4.36-4.37ZM397,400l-4.37,4.36L388.22,400l4.36-4.37Zm1.41,1.41,4.37,4.37-4.36,4.37L394,405.8Zm1.42-1.41,4.37-4.37,4.36,4.37-4.36,4.36Zm10.15,1.41,4.36,4.37-4.36,4.37-4.37-4.37Zm5.78,5.78,4.37,4.37-2.83,2.83h-3.08l-2.83-2.83ZM411.34,400l4.37-4.37,4.37,4.37-4.37,4.36Zm0-11.57,4.37-4.36,4.37,4.36-4.37,4.37Zm3-17.34-4.36,4.37-4.37-4.37,3.91-3.91h.92Zm-10.14-1.41-2.5-2.5h5Zm-1.42,1.41-4.36,4.37L394,371.11l3.91-3.91h.92Zm-7.65-3.91-2.5,2.5-2.49-2.5Zm-7.82,0,3.91,3.91-4.37,4.37-3.8-3.81-.08-1,3.42-3.43Zm-3.74,0-.81.81h0l-.07-.81Zm-.27,7.55,2.14,2.14-1.82,1.82Zm1.19,14.65-.17-2.07h0l1.12,1.12-.95.95Zm.21,2.63,2.15-2.16,4.37,4.37-4.37,4.36L385,396.84Zm.65,8.08v-.19l.1.1-.09.09Zm.76,9.31-.55-6.7,1.29-1.29,4.37,4.37-4.37,4.36-.74-.74Zm.4,5-.08-1,.42-.42,1.42,1.42Zm1.76-2.83,4.36-4.37,4.37,4.37-2.83,2.83H391Zm8.73,2.83,1.42-1.42,1.42,1.42Zm5.66,0-2.83-2.83,4.37-4.37,4.36,4.37-2.82,2.83Zm5.9,0,1.42-1.42,1.42,1.42Zm13.32,0h-1.76l1.42-1.42.42.42Zm.41-5-.75.74-4.37-4.36,4.37-4.37,1.29,1.29Zm.77-9.51,0,.2-.09-.09.11-.11Zm.25-3.07-1.77,1.76-4.37-4.36,4.37-4.37,2.16,2.16Zm.6-7.43-1-1,1.13-1.12Zm1.19-14.67-.32,4-1.83-1.83,2.15-2.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 377.75,
    y: 363.41,
    width: 52.8,
    height: 5.57,
    rx: 1.64,
    transform: "translate(808.29 732.4) rotate(180)",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.55,
    y: 413.41,
    width: 45.19,
    height: 5.57,
    rx: 1.64,
    style: {
      fill: "#1976D2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "203.55 216.17 216.4 216.17 212.98 252.96 233.3 256.01 233.3 258.57 190.5 258.57 190.5 256.01 199.26 252.96 203.55 216.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.43,239.52a4,4,0,0,1-4,4.47H171.61a5,5,0,0,1-4.87-4.47l-4.62-49.8a4.31,4.31,0,0,1,.1-1.45,4,4,0,0,1,3.93-3h77.79a5,5,0,0,1,4.87,4.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.61,241.48a2.47,2.47,0,0,1-2.37-2.19l-4.62-49.8a1.73,1.73,0,0,1,0-.61,1.46,1.46,0,0,1,1.5-1.13h77.79a2.49,2.49,0,0,1,2.38,2.2l4.62,49.8a1.65,1.65,0,0,1-.38,1.26,1.5,1.5,0,0,1-1.16.47Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.61,241.48a2.47,2.47,0,0,1-2.37-2.19l-4.62-49.8a1.73,1.73,0,0,1,0-.61,1.46,1.46,0,0,1,1.5-1.13h77.79a2.49,2.49,0,0,1,2.38,2.2l4.62,49.8a1.65,1.65,0,0,1-.38,1.26,1.5,1.5,0,0,1-1.16.47Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.34 418.98 150.22 418.98 139.21 265.74 147.34 265.74 156.34 418.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.35 418.98 150.22 418.98 139.75 273.35 139.21 265.98 147.34 265.98 147.78 273.35 156.35 418.98",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.78 272.98 139.75 272.98 139.21 265.98 147.34 265.98 147.78 272.98",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.3 418.98 295.18 418.98 294.18 265.74 302.3 265.74 301.3 418.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.31 265.98 302.15 290.71 301.31 418.98 295.18 418.98 294.34 290.71 294.18 265.98 302.31 265.98",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.31 265.98 302.15 290.98 294.34 290.98 294.18 265.98 302.31 265.98",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.34 418.98 360.22 418.98 349.21 265.74 357.34 265.74 366.34 418.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.35 418.98 360.22 418.98 349.75 273.35 349.21 265.98 357.34 265.98 357.78 273.35 366.35 418.98",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.78 272.98 349.75 272.98 349.21 265.98 357.34 265.98 357.78 272.98",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.26 418.98 80.14 418.98 89.14 265.74 97.27 265.74 86.26 418.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.27 265.98 96.73 273.35 86.26 418.98 80.14 418.98 88.7 273.35 89.14 265.98 97.27 265.98",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.14 265.98 97.27 265.98 96.73 272.98 88.7 272.98 89.14 265.98",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7,261.9H363.78a0,0,0,0,1,0,0v5.51a2.16,2.16,0,0,1-2.16,2.16H84.86a2.16,2.16,0,0,1-2.16-2.16V261.9A0,0,0,0,1,82.7,261.9Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7,261.9H363.78a0,0,0,0,1,0,0v5.51a2.16,2.16,0,0,1-2.16,2.16H84.86a2.16,2.16,0,0,1-2.16-2.16V261.9A0,0,0,0,1,82.7,261.9Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7,
    y: 261.9,
    width: 281.08,
    height: 3.84,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.58,262.9H78.9a2.16,2.16,0,0,1-2.16-2.16h0a2.17,2.17,0,0,1,2.16-2.17H367.58a2.17,2.17,0,0,1,2.16,2.17h0A2.16,2.16,0,0,1,367.58,262.9Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.58,262.9H78.9a2.16,2.16,0,0,1-2.16-2.16h0a2.17,2.17,0,0,1,2.16-2.17H367.58a2.17,2.17,0,0,1,2.16,2.17h0A2.16,2.16,0,0,1,367.58,262.9Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.28 258.57 217.26 254.84 257.81 254.84 276.49 256.71 277.2 258.57 216.28 258.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.81 254.84 257.81 258.57 216.28 258.57 217.26 254.84 257.81 254.84",
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.55 216.17 130.4 216.17 116.98 252.96 137.3 256.01 137.3 258.57 94.5 258.57 94.5 256.01 103.27 252.96 117.55 216.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.17,189.16a5.58,5.58,0,0,0-5.25-4.51H80.13a3.58,3.58,0,0,0-3.68,3,4.3,4.3,0,0,0,0,1.47l8.85,50.3A5.56,5.56,0,0,0,90.58,244h69.79a3.66,3.66,0,0,0,3.65-4.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,239.46a3.66,3.66,0,0,1-3.65,4.51H92.58a5.56,5.56,0,0,1-5.25-4.51l-8.85-50.3a4.3,4.3,0,0,1,0-1.47,3.58,3.58,0,0,1,3.68-3h67.79a5.58,5.58,0,0,1,5.25,4.51Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.37,241.45a2.78,2.78,0,0,1-2.57-2.22L81,188.93a1.88,1.88,0,0,1,0-.62,1.33,1.33,0,0,1,1.41-1.13h67.79a2.76,2.76,0,0,1,2.56,2.21l8.86,50.3a1.62,1.62,0,0,1-.28,1.28,1.4,1.4,0,0,1-1.11.48Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.37,241.45a2.78,2.78,0,0,1-2.57-2.22L81,188.93a1.88,1.88,0,0,1,0-.62,1.33,1.33,0,0,1,1.41-1.13h67.79a2.76,2.76,0,0,1,2.56,2.21l8.86,50.3a1.62,1.62,0,0,1-.28,1.28,1.4,1.4,0,0,1-1.11.48Z",
    style: {
      fill: "#1976D2",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.55 216.17 298.4 216.17 284.98 252.96 305.3 256.01 305.3 258.57 262.5 258.57 262.5 256.01 271.26 252.96 285.55 216.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.58,189.72a4.68,4.68,0,0,0-4.64-4.47H256.15a4.23,4.23,0,0,0-4.08,3,4.37,4.37,0,0,0-.18,1.46l2.05,49.79a4.68,4.68,0,0,0,4.64,4.46h69.79a4.24,4.24,0,0,0,4.26-4.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.63,239.51a4.24,4.24,0,0,1-4.26,4.46H260.58a4.68,4.68,0,0,1-4.64-4.46l-2.05-49.79a4.37,4.37,0,0,1,.18-1.46,4.23,4.23,0,0,1,4.08-3h67.79a4.68,4.68,0,0,1,4.64,4.47Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.71,241.47a2.31,2.31,0,0,1-2.26-2.19l-2.05-49.79a2,2,0,0,1,.06-.62,1.57,1.57,0,0,1,1.56-1.12h67.79a2.34,2.34,0,0,1,2.27,2.2l2.05,49.79a1.69,1.69,0,0,1-.45,1.26,1.63,1.63,0,0,1-1.18.47Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.71,241.47a2.31,2.31,0,0,1-2.26-2.19l-2.05-49.79a2,2,0,0,1,.06-.62,1.57,1.57,0,0,1,1.56-1.12h67.79a2.34,2.34,0,0,1,2.27,2.2l2.05,49.79a1.69,1.69,0,0,1-.45,1.26,1.63,1.63,0,0,1-1.18.47Z",
    style: {
      fill: "#1976D2",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.71,241.47a2.31,2.31,0,0,1-2.26-2.19l-2.05-49.79a2,2,0,0,1,.06-.62,1.57,1.57,0,0,1,1.56-1.12h67.79a2.34,2.34,0,0,1,2.27,2.2l2.05,49.79a1.69,1.69,0,0,1-.45,1.26,1.63,1.63,0,0,1-1.18.47Z",
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.45 193.05 272.68 193.05 272.64 192.12 322.41 192.12 322.45 193.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.57 195.89 278.29 195.89 278.25 194.96 322.53 194.96 322.57 195.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.7 198.73 294.71 198.73 294.67 197.81 322.66 197.81 322.7 198.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.83 201.57 286.49 201.57 286.44 200.65 322.78 200.65 322.83 201.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.95 204.42 298.85 204.42 298.81 203.49 322.91 203.49 322.95 204.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.33 213.09 273.57 213.09 273.53 212.16 323.29 212.16 323.33 213.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.46 215.93 279.18 215.93 279.14 215 323.42 215 323.46 215.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.59 218.77 295.6 218.77 295.56 217.84 323.55 217.84 323.59 218.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.71 221.62 287.37 221.62 287.33 220.69 323.67 220.69 323.71 221.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.84 224.46 299.73 224.46 299.69 223.53 323.8 223.53 323.84 224.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.15 223.27 171.73 223.27 169.18 194.87 212.6 194.87 215.15 223.27",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.15 223.27 171.73 223.27 169.18 194.87 212.6 194.87 215.15 223.27",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.43 221.85 173.19 221.85 171.25 200.19 211.49 200.19 213.43 221.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.67 204.36 174.9 204.36 174.81 203.43 204.58 203.43 204.67 204.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.44 207.21 175.16 207.21 175.07 206.28 189.35 206.28 189.44 207.21",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.4 210.06 175.41 210.06 175.33 209.13 193.32 209.13 193.4 210.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.01 212.92 175.67 212.92 175.58 211.99 181.92 211.99 182.01 212.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.03 215.77 175.92 215.77 175.84 214.84 179.94 214.84 180.03 215.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.82 237.47 200.41 237.47 197.85 209.07 241.27 209.07 243.82 237.47",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.82 237.47 200.41 237.47 197.85 209.07 241.27 209.07 243.82 237.47",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.11 236.05 201.87 236.05 199.92 214.39 240.16 214.39 242.11 236.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.34 218.56 203.57 218.56 203.49 217.63 233.26 217.63 233.34 218.56",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.11 221.41 203.83 221.41 203.75 220.48 218.03 220.48 218.11 221.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.08 224.27 204.09 224.27 204 223.33 221.99 223.33 222.08 224.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.68 227.12 204.34 227.12 204.26 226.19 210.6 226.19 210.68 227.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.71 229.97 204.6 229.97 204.52 229.04 208.62 229.04 208.71 229.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.34 236.05 91.7 236.05 83.78 191.92 151.43 191.92 159.34 236.05",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.35 234.32 92.75 234.32 86.23 197.98 103.83 197.98 110.35 234.32",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.93 234.32 157.61 234.32 151.09 197.98 105.42 197.98 111.93 234.32",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "102.07 201.69 89.3 201.69 89.14 200.77 101.91 200.77 102.07 201.69"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "97.08 204.44 89.8 204.44 89.63 203.52 96.91 203.52 97.08 204.44"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "100.28 207.19 90.29 207.19 90.12 206.26 100.11 206.26 100.28 207.19"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "97.12 209.93 90.78 209.93 90.61 209.01 96.95 209.01 97.12 209.93"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "95.38 212.68 91.27 212.68 91.11 211.76 95.21 211.76 95.38 212.68"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "104.53 215.43 91.77 215.43 91.6 214.5 104.37 214.5 104.53 215.43"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "99.54 218.17 92.26 218.17 92.09 217.25 99.37 217.25 99.54 218.17"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "102.74 220.92 92.75 220.92 92.58 220 102.57 220 102.74 220.92"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "99.58 223.66 93.24 223.66 93.08 222.74 99.42 222.74 99.58 223.66"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "97.84 226.41 93.73 226.41 93.57 225.49 97.67 225.49 97.84 226.41"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "100.57 229.16 94.23 229.16 94.06 228.23 100.4 228.23 100.57 229.16"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "98.83 231.9 94.72 231.9 94.55 230.98 98.66 230.98 98.83 231.9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }, _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "142.07 201.69 109.3 201.69 109.14 200.77 141.91 200.77 142.07 201.69"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "137.08 204.44 109.8 204.44 109.63 203.52 136.91 203.52 137.08 204.44"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "140.28 207.19 110.29 207.19 110.12 206.26 140.11 206.26 140.28 207.19"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "137.12 209.93 110.78 209.93 110.61 209.01 136.95 209.01 137.12 209.93"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "135.38 212.68 111.27 212.68 111.11 211.76 135.21 211.76 135.38 212.68"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "144.53 215.43 111.77 215.43 111.6 214.5 144.37 214.5 144.53 215.43"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "139.54 218.17 112.26 218.17 112.09 217.25 139.37 217.25 139.54 218.17"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "142.74 220.92 112.75 220.92 112.58 220 142.57 220 142.74 220.92"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "139.58 223.66 113.24 223.66 113.08 222.74 139.42 222.74 139.58 223.66"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "137.84 226.41 113.73 226.41 113.57 225.49 137.67 225.49 137.84 226.41"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "140.57 229.16 114.23 229.16 114.06 228.23 140.4 228.23 140.57 229.16"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "138.82 231.9 114.72 231.9 114.55 230.98 138.66 230.98 138.82 231.9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.77,
    y: 119.82,
    width: 36.13,
    height: 36.13,
    rx: 3.03,
    transform: "translate(601.68 275.77) rotate(180)",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,152.74s-1.84,10.18-15.29,14.77c0,0,7.64-7.39,7.64-14.77Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.87,134v-2.19l-1.13-.11a5.73,5.73,0,0,0-.84-2l.72-.88-1.55-1.55-.87.73a5.81,5.81,0,0,0-2-.84l-.11-1.13h-2.19l-.11,1.13a5.81,5.81,0,0,0-2,.84l-.87-.73-1.55,1.55.72.88a5.73,5.73,0,0,0-.84,2l-1.13.11V134l1.13.1a5.66,5.66,0,0,0,.84,2l-.72.88,1.55,1.55.87-.73a5.81,5.81,0,0,0,2,.84l.11,1.13h2.19l.11-1.13a5.81,5.81,0,0,0,2-.84l.87.73,1.55-1.55-.72-.88a5.66,5.66,0,0,0,.84-2Zm-6.9,1.87a3,3,0,1,1,3-3A3,3,0,0,1,296,135.87Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.74,140.18v-1.72l-.88-.08a4.66,4.66,0,0,0-.66-1.59l.57-.68-1.22-1.22-.68.57a4.66,4.66,0,0,0-1.59-.66l-.08-.88h-1.72l-.08.88a4.53,4.53,0,0,0-1.58.66l-.69-.57-1.21,1.22.56.68a4.66,4.66,0,0,0-.66,1.59l-.88.08v1.72l.88.08a4.53,4.53,0,0,0,.66,1.58l-.56.69,1.21,1.21.69-.56a4.53,4.53,0,0,0,1.58.66l.08.88h1.72l.08-.88a4.66,4.66,0,0,0,1.59-.66l.68.56,1.22-1.21-.57-.69a4.53,4.53,0,0,0,.66-1.58Zm-5.4,1.46a2.32,2.32,0,1,1,2.32-2.32A2.32,2.32,0,0,1,306.34,141.64Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.87,145.05v-1.44l-.75-.07a3.74,3.74,0,0,0-.55-1.33l.48-.58-1-1-.58.48a3.92,3.92,0,0,0-1.33-.56l-.07-.74h-1.44l-.07.74a3.92,3.92,0,0,0-1.33.56l-.58-.48-1,1,.48.58a3.74,3.74,0,0,0-.55,1.33l-.75.07v1.44l.75.07a3.9,3.9,0,0,0,.55,1.33l-.48.57,1,1,.58-.47a3.9,3.9,0,0,0,1.33.55l.07.74h1.44l.07-.74a3.9,3.9,0,0,0,1.33-.55l.58.47,1-1-.48-.57a3.9,3.9,0,0,0,.55-1.33Zm-4.54,1.23a2,2,0,1,1,1.95-1.95A2,2,0,0,1,298.33,146.28Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "294.06 408.2 286.09 407.11 284.99 388.17 292.94 389.27 294.06 408.2",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.94 389.27 284.99 388.18 285.62 399 293.57 399.7 292.94 389.27",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.49,406.15l9-.57a.57.57,0,0,1,.63.51h0l.88,7.1a1.4,1.4,0,0,1-1.31,1.5c-3.14.15-4.65.06-8.61.28-2.43.14-7.22.66-10.58.33s-2.94-3.63-1.49-3.79c3.43-.39,8-2.91,10.13-4.83A2.24,2.24,0,0,1,285.49,406.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.3,407.12h0c0-.14-.13-2.41-1-3.13a1.16,1.16,0,0,0-.9-.21.77.77,0,0,0-.68.6,2.91,2.91,0,0,0,.79,1.84,3.25,3.25,0,0,0-2.22-.41.74.74,0,0,0-.41.56,1,1,0,0,0,.3,1,2.13,2.13,0,0,0,1.52.3,9.31,9.31,0,0,0,2.1-.42.08.08,0,0,0,.07,0,.33.33,0,0,0,0-.06s.19,0,.2-.07l.17,0Zm-2.21-2.66c0-.11.07-.25.33-.3h.09a.51.51,0,0,1,.41.15c.51.42.65,1.69.68,2.45l-.16-.09A3.78,3.78,0,0,1,283.09,404.46Zm-1.64,2.65a.71.71,0,0,1-.18-.66.33.33,0,0,1,.2-.27c.51-.24,1.88.35,2.85.88C282.91,407.43,281.85,407.45,281.45,407.11Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.74,296.88l1.94-12.18L340.34,282s4.75,25.34,1.1,32.09c-6.51,12.05-41.61,6-51.89,7.15,6.14,25.11,5.54,74.18,5.54,74.18l-14.67,1.12s-11.28-52.87-13.57-78C265.31,301.62,279.36,302,293.74,296.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.74,296.88l1.94-12.18L340.34,282s4.75,25.34,1.1,32.09c-6.51,12.05-41.61,6-51.89,7.15,6.14,25.11,5.54,74.18,5.54,74.18l-14.67,1.12s-11.28-52.87-13.57-78C265.31,301.62,279.36,302,293.74,296.88Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.07,193.7c.2,1.88-.6,3.5-1.79,3.64s-2.33-1.29-2.54-3.16.6-3.51,1.79-3.64S260.86,191.82,261.07,193.7Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.1,203.37a12,12,0,0,0,.62,1.24,12.91,12.91,0,0,0,5.58,5.29,12.24,12.24,0,0,0,1.84.75,11.77,11.77,0,0,0,10.05-1.24,12,12,0,0,0,3.36-3.28c3.82-5.44,2.79-10.8,1.77-20A12.66,12.66,0,0,0,265,176.61C256.67,181.76,257.74,195.51,261.1,203.37Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.3,209.9a12.24,12.24,0,0,0,1.84.75,11.77,11.77,0,0,0,10.05-1.24,14,14,0,0,0-2.15-2.82A18.23,18.23,0,0,0,267.3,209.9Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.39,212.34c-1.57,5.94-11.76,10.71-11.76,10.71s-6.87,2.18-6.83-.44c3.08-2.79,3.7-5.48,3.06-8a11.73,11.73,0,0,0-2.19-4.15,24.76,24.76,0,0,0-1.7-2l6-16C280.14,199.06,285,210.66,291.39,212.34Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.39,183.24s-2.58,8.69,6.33,14.93c0,0,3.75,8,5.84,9s6.8.39,8.4,0,9.81-7.23,7.44-23.26-15.84-11-15.84-11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.93,194a6,6,0,0,1-2.34,4.56c-1.72,1.1-3.38-1.31-3.58-4.09-.16-2.47.52-6.09,2.58-6S270.16,191.46,269.93,194Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.08,172.24s-9.89-2.71-17.61,1.38c0,0,1.52-1,1.06-2.26s-4,3.3-4,3.3,1.19-4.34.46-4.74-5.27,6.4-3,9.7c0,0-4.4-3-3.62-.66s.78,6.39,10.93,4.41S280.08,172.24,280.08,172.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.74,
    y1: 194.18,
    x2: 263.99,
    y2: 191.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.67,215.88s6.69-8.26,17.37-8.15l6.53,5.45Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.67,215.88s6.69-8.26,17.37-8.15l6.53,5.45Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.27,250.13,224,246.82s-6.06-1.13-8.57-.56-8,8.09-7.91,9,9.6,3.16,9.81,3.16,4.32-2.32,4.32-2.32l6.71,2.32Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.81 396.14 279.18 397.3 277.67 389.75 297.04 388.85 296.81 396.14",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.81 396.14 279.18 397.3 277.67 389.75 297.04 388.85 296.81 396.14",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.68 408.13 267.66 408.72 262.64 390.43 270.65 389.85 275.68 408.13",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.58,409l-.14,0h0c0-.12-.41-2.37-1.38-2.9a.9.9,0,0,0-.8,0,.7.7,0,0,0-.49.73,3,3,0,0,0,1.18,1.63,3.21,3.21,0,0,0-2.24.06.7.7,0,0,0-.28.63,1,1,0,0,0,.51.94,2.15,2.15,0,0,0,1.56,0,10,10,0,0,0,2-.84h.07s0-.05,0-.07A.11.11,0,0,0,266.58,409Zm-2.41-2.24c0-.11,0-.25.27-.35l.09,0a.55.55,0,0,1,.43.06c.58.31,1,1.53,1.17,2.26l-.18-.05C265.16,408.19,264.24,407.29,264.17,406.75Zm-1.05,2.94a.71.71,0,0,1-.31-.61.36.36,0,0,1,.13-.31c.46-.34,1.92,0,3,.27C264.61,409.7,263.59,409.94,263.12,409.69Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.65 389.85 262.64 390.44 265.51 400.89 273.43 399.92 270.65 389.85",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.92,399.6,274,395.45s-8.43-47.58-17-64.08c.64-.21,1.49-.48,2.54-.79,1.89-.57,4.4-1.28,7.35-2.1,20.52-5.69,62.11-16.36,62.11-16.36l-19-17.73s-75.68,11.54-77.25,31.48C232.06,335.46,259.92,399.6,259.92,399.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.87 395.76 258.86 400.57 255.81 393.5 274.57 388.58 275.87 395.76",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.87 395.76 258.86 400.57 255.81 393.5 274.57 388.58 275.87 395.76",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.88,407.9l8.68-2.42a.57.57,0,0,1,.72.36h0l2.35,6.76a1.43,1.43,0,0,1-1,1.75c-3.05.79-4.54,1-8.37,2.06-2.35.65-6.93,2.15-10.28,2.53s-3.63-2.94-2.25-3.39c3.28-1.1,7.21-4.52,8.91-6.84A2.22,2.22,0,0,1,266.88,407.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.29,224s12.65-14.16,29.54-12.7,33.81,14.5,42.22,35,11,51.5,11,51.5-27.34,7.82-55.12.69A295.54,295.54,0,0,0,261.29,224Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.29,224s12.65-14.16,29.54-12.7,33.81,14.5,42.22,35,11,51.5,11,51.5-27.34,7.82-55.12.69A295.54,295.54,0,0,0,261.29,224Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.29,224c-4.26,4.43-16.45,24.74-19.92,25.5s-8.52-2.37-12.48-1.18-8,4.8-7.1,7.1,10.21,8.46,21.74,8.8c9.87.28,30.67-24.29,30.67-24.29C274.2,230.38,261.29,224,261.29,224Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.29,224c-4.26,4.43-16.45,24.74-19.92,25.5s-8.52-2.37-12.48-1.18-8,4.8-7.1,7.1,10.21,8.46,21.74,8.8c9.87.28,30.67-24.29,30.67-24.29C274.2,230.38,261.29,224,261.29,224Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,304.56c-28.68,5.54-56.81-5.8-56.81-5.8s-.07-2.06-.43-5.27h0c-.13-1.22-.31-2.61-.53-4.11s-.46-2.81-.76-4.32a70.84,70.84,0,0,0-3.63-12.63c-1.59-3.95-2.83-7.2-3.78-9.87q-.21-.57-.39-1.11c-.41-1.17-.76-2.22-1.06-3.15-2-6.36-1.77-7.57-1.77-7.57,7.26,1,7.8-13.93-1.91-25.05a12.47,12.47,0,0,0-8-4.32s-1-1.58,9.25-7.35c5.52-3.11,11.7-.82,16.27-.82,7.34,0,8.44-1,8.44-1,12,0,26.48,15.83,35.83,34.66.47.94.93,1.89,1.37,2.85s.9,2,1.33,3a88.05,88.05,0,0,1,6.56,23c.1.81.2,1.59.28,2.35.13,1.08.24,2.11.35,3.1.13,1.22.24,2.38.34,3.47C345.77,303.8,343,304.56,343,304.56Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.1,262.55l11.81,9.65-4.4,12.85a70.84,70.84,0,0,0-3.63-12.63C279.29,268.47,278.05,265.22,277.1,262.55Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.57 252.71 312.77 272.08 309.21 288.82 288.91 272.2 295.57 252.71",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.72 248.83 333.66 267.01 329.06 290.42 312.77 272.08 317.72 248.83",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.32,278l-9.66-11,2.82-14.37a88.05,88.05,0,0,1,6.56,23C343.14,276.49,343.24,277.27,343.32,278Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.15,249.65l-3,12.57L316.57,245.5l-5,22.11L294.26,247,287.84,269l-11.13-7.6c-.41-1.17-.76-2.22-1.06-3.15l11,7.54,6.7-23,17.13,20.43,4.93-21.87L331,258.13l2.74-11.33C334.25,247.74,334.71,248.69,335.15,249.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344,284.6l-7.38-8.6-5,24.56-16.41-18.05-3.58,14.63-20.4-17.54-5.44,13.88c-.13-1.22-.31-2.61-.53-4.11l5.14-13.13,20.06,17.25,3.7-15.1,16.29,17.91,5-24.7,8.19,9.53C343.8,282.35,343.91,283.51,344,284.6Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M266.26,317.44h89.92a0,0,0,0,1,0,0v6.69a5,5,0,0,1-5,5H271.26a5,5,0,0,1-5-5v-6.69A0,0,0,0,1,266.26,317.44Z",
    transform: "translate(622.44 646.57) rotate(180)",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.26,317.44h89.92a0,0,0,0,1,0,0v6.69a5,5,0,0,1-5,5H271.26a5,5,0,0,1-5-5v-6.69A0,0,0,0,1,266.26,317.44Z",
    transform: "translate(622.44 646.57) rotate(180)",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.25,395.68l-28.81-2.83v-40.5H313v40.48l-28.93,2.85a5.6,5.6,0,0,0-5.06,5.58v4.33h79.28v-4.33A5.6,5.6,0,0,0,353.25,395.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.25,395.68l-28.81-2.83v-40.5H313v40.48l-28.93,2.85a5.6,5.6,0,0,0-5.06,5.58v4.33h79.28v-4.33A5.6,5.6,0,0,0,353.25,395.68Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.08,
    cy: 410.95,
    r: 7.47,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.26,
    cy: 410.95,
    r: 7.47,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.05,325h15.35a0,0,0,0,1,0,0v31.93a4.13,4.13,0,0,1-4.13,4.13h-7.09a4.13,4.13,0,0,1-4.13-4.13V325A0,0,0,0,1,311.05,325Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.05,325h15.35a0,0,0,0,1,0,0v31.93a4.13,4.13,0,0,1-4.13,4.13h-7.09a4.13,4.13,0,0,1-4.13-4.13V325A0,0,0,0,1,311.05,325Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.64,325S316,279.31,318.4,212.65a14.82,14.82,0,0,1,14.82-14.24H359.8a14.83,14.83,0,0,1,14.84,14.75c.1,24.22-1.59,73.72-15.25,114Z",
    style: {
      fill: "#1976D2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.64,325S316,279.31,318.4,212.65a14.82,14.82,0,0,1,14.82-14.24H359.8a14.83,14.83,0,0,1,14.84,14.75c.1,24.22-1.59,73.72-15.25,114Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.71,324.42s13.65-48.56,15.91-110a13.66,13.66,0,0,1,13.67-13.14H364.8a13.68,13.68,0,0,1,13.69,13.61c.09,22.33-1.47,72.45-14.07,109.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.42,324.42H310.71s13.65-48.56,15.91-110a13.66,13.66,0,0,1,13.67-13.14H364.8a13.68,13.68,0,0,1,13.69,13.61C378.58,237.18,377,287.3,364.42,324.42Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.23,289.12s-29.14-5.89-57.27-3,13.24,39.61,13.24,39.61H283s-21.92-23.31-20.7-29.11,56.42,1.85,56.42,1.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.23,289.12s-29.14-5.89-57.27-3,13.24,39.61,13.24,39.61H283s-21.92-23.31-20.7-29.11,56.42,1.85,56.42,1.85Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.42,324.42H316.71s13.65-48.56,15.91-110a13.66,13.66,0,0,1,13.67-13.14H364.8a13.68,13.68,0,0,1,13.69,13.61C378.58,237.18,377,287.3,364.42,324.42Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.06,
    y: 323.28,
    width: 102.33,
    height: 5.84,
    rx: 2.01,
    transform: "translate(628.44 652.41) rotate(-180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.06,
    y: 323.28,
    width: 102.33,
    height: 5.84,
    rx: 2.01,
    transform: "translate(628.44 652.41) rotate(-180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammerRafiki);
export default __webpack_public_path__ + "static/media/Programmer-rafiki.e5be14c57d0a7606771a95ab6e1bc5af.svg";
export { ForwardRef as ReactComponent };